webpackJsonp([1],{

/***/ "/MAV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5UXz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5aCn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7bK5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HXhP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J4AD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JAIY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KUHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-gtag/dist/vue-gtag.esm.js
var vue_gtag_esm = __webpack_require__("Z3T5");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61ddc7ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("Om6c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3a0bff0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("JAIY")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13cf244c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("Z1YF")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-13cf244c"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents', 'isMobileFontLarge'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleFontSize: 'TOGGLE_FONT_SIZE'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d2c09f7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"}},[_c('div',{staticClass:"nav-menu-button",class:{ mobileFontLarge: _vm.isMobileFontLarge },attrs:{"id":"mobile-font-size-toggle"},on:{"click":_vm.toggleFontSize}},[_c('span',{staticClass:"font-size-toggle-small"},[_vm._v("Aa")]),_vm._v(" "),_c('span',{staticClass:"font-size-toggle-large"},[_vm._v("Aa")])]),_vm._v(" "),_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("nSix")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-1d2c09f7"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f86d1c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("7bK5")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-9f86d1c4"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0878514e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("r8RT")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c2f03a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("5UXz")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bdf4d00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("5aCn")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/vue-slider-component.umd.min.js
var vue_slider_component_umd_min = __webpack_require__("lCKi");
var vue_slider_component_umd_min_default = /*#__PURE__*/__webpack_require__.n(vue_slider_component_umd_min);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/theme/material.css
var material = __webpack_require__("KUHQ");
var material_default = /*#__PURE__*/__webpack_require__.n(material);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: [],
      zoomValue: 1
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    VueSlider: vue_slider_component_umd_min_default.a
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "contentsPinned", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage", "fullscreenEnabled", "zoomScrollEnabled"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    slideZoom: "SLIDE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER",
    toggleFullscreen: "TOGGLE_FULLSCREEN"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    },
    updateSliderZoom: function updateSliderZoom() {
      Publish.$store.commit("SLIDE_ZOOM", { zoomValue: this.zoomValue });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dfa9eb26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.zoomScrollEnabled)?_c('li',{staticClass:"nav-bar__link nav-bar__zoom-slider"},[_c('vue-slider',{ref:"zoomSlider",attrs:{"min":1,"max":2,"interval":0.01,"tooltip-placement":'bottom'},on:{"change":function($event){_vm.updateSliderZoom()},"click":_vm.slideZoom},model:{value:(_vm.zoomValue),callback:function ($$v) {_vm.zoomValue=$$v},expression:"zoomValue"}})],1):_vm._e(),_vm._v(" "),(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomNavEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled && _vm.contentsPinned)?_c('li',{staticClass:"nav-bar__link hidden-large",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}}):(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled && !_vm.isMobile)?_c('li',{staticClass:"nav-bar__link",on:{"click":_vm.toggleFullscreen}},[_c('feather-icon',{attrs:{"icon":"maximize"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("rMvo")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45475472","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("HXhP")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be6e2d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("OT+5")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'contentsPinned', 'contentsNumbers', 'contentsTitles']), {

    currentPageIndex: function currentPageIndex() {
      return this.page[0].pageIndex;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5440ef94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.currentPageIndex && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}},[(_vm.contentsNumbers)?_c('p',{staticClass:"contents-item__text--index"},[_vm._v("\n          "+_vm._s(_vm.currentPageIndex + 1)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsTitles)?_c('p',{class:['contents-item__text--title', _vm.contentsPinned ? '' : '']},[_vm._v("\n          "+_vm._s(_vm.page[0].title)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsPinned && _vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.currentPageIndex, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}}):_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]):_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("/MAV")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'showContents', 'contentsPinned']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-688d3493","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[(_vm.contentsPinned)?_c('ul',{staticClass:"contents-list"},_vm._l((_vm.titledPages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})})):_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("hxKv")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07dfdf84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("hLNX")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277a16ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b1b3a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("Tnot")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a0b1688","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("J4AD")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e710b5e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("o4GY")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-4e710b5e"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile", "fullscreenEnabled"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-399a74da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomNavEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"maximize-2"}}),_vm._v(" "),_c('p',[_vm._v("Toggle fullscreen")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n\t\t\t\t\t\t\t\t\t\tc-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n\t\t\t\t\t\t\t\t\t\tc-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n\t\t\t\t\t\t\t\t\t\th85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n\t\t\t\t\t\t\t\t\t\tc-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n\t\t\t\t\t\t\t\t\t\tM123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n\t\t\t\t\t\t\t\t\t\tc-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n\t\t\t\t\t\t\t\t\t\tc-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n\t\t\t\t\t\t\t\t\t\tc0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n\t\t\t\t\t\t\t\t\t\tc6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n\t\t\t\t\t\t\t\t\t\tc3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n\t\t\t\t\t\t\t\t\t\tc-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n\t\t\t\t\t\t\t\t\t\tC70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n\t\t\t\t\t\t\t\t\t\tc-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n\t\t\t\t\t\t\t\t\t\tc6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n\t\t\t\t\t\t\t\t\t\tc14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n\t\t\t\t\t\t\t\t\t\tL154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("hIWI")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d498b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("WpSr")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'contentsPinned', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL', 'isMobileFontLarge'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4af51f4b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'mobile-font-large': _vm.isMobileFontLarge, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{ref:"navBar",attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{class:{contentsPinned: _vm.contentsPinned},style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{class:[_vm.contentsPinned ? 'navigation-link--next__contents' : 'navigation-link--next'],attrs:{"to":_vm.nextPageURI}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("Vhpl")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';
var TOGGLE_FONT_SIZE = 'TOGGLE_FONT_SIZE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';
var SLIDE_ZOOM = 'SLIDE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';
var TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';
var UPDATE_FULLSCREEN = 'UPDATE_FULLSCREEN';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
var UPDATE_CONTENT_PANEL = 'UPDATE_CONTENT_PANEL';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Olympic Review - Issue 124",
  "shortTitle": "",
  "description": "",
  "width": 707,
  "height": 875,
  "currentLanguage": "EN",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "http://olympicreview.touchlines.com/124"
  }, {
    "code": "FR",
    "text": "French",
    "href": "http://revueolympique.touchlines.com/124"
  }],
  "basePath": "/124",
  // "basePath": ".",
  "companyLogo": "1-logo-1.png",
  "publishURL": "http://olympic-review.s3-website-eu-west-1.amazonaws.com/124/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true
    },
    "languagesEnabled": true,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 1-title-1\" style=\"top:3px;left:1px;\" src=\"/124/static/_content/1-title-1.png\"/>\n        <img class=\"abs halfScale 1-title-2\" style=\"top:152px;left:251px;\" src=\"/124/static/_content/1-title-2.png\"/>\n        <img class=\"abs halfScale 1-header\" style=\"top:14px;left:237px;\" src=\"/124/static/_content/1-header-1.png\"/>\n        <img class=\"abs halfScale 1-date\" style=\"top:159px;left:523px;\" src=\"/124/static/_content/1-date-1.png\"/>\n        \n        <img class=\"abs halfScale 1-subtitle\" style=\"top:255px;left:31px;\" src=\"/124/static/_content/1-subtitle-1.png\"/>\n        <img class=\"abs halfScale 1-caption\" style=\"top:350px;left:32px;\" src=\"/124/static/_content/1-caption-1.png\"/>\n        <img class=\"abs halfScale 1-caption\" style=\"top:453px;left:32px;\" src=\"/124/static/_content/1-caption-2.png\"/>\n        <img class=\"abs halfScale 1-caption\" style=\"top:509px;left:32px;\" src=\"/124/static/_content/1-caption-3.png\"/>\n        <img class=\"abs halfScale 1-caption\" style=\"top:565px;left:32px;\" src=\"/124/static/_content/1-caption-4.png\"/>\n        <img class=\"abs halfScale 1-line\" style=\"top:498px;left:32px;\" src=\"/124/static/_content/1-line-1.png\"/>\n        <img class=\"abs halfScale 1-line\" style=\"top:554px;left:32px;\" src=\"/124/static/_content/1-line-2.png\"/>\n\n        <img class=\"abs halfScaleC 1-logo\" style=\"top:799px;left:-27px;\" src=\"/124/static/_content/1-logo-1.png\"/>\n\n        <div class=\"addContentLink abs\" style=\"top:846px; left:621px; width:70px; height:13px;\">\n          <a href=\"https://olympics.com/en/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.fromTo(cOf(\"1-title-1\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"1-title-2\"), 0.6, {opacity:0, y:50}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.2)\n          .fromTo(cOf(\"1-header\"), 0.6, {opacity:0, y:-50}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.4)\n          .fromTo(cOf(\"1-date\"), 0.6, {opacity:0, y:50}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.4)\n\n          .fromTo(cOf(\"1-subtitle\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n          .staggerFromTo(cOf(\"1-caption\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.1, 1.8)\n          .staggerFromTo(cOf(\"1-line\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.1, 2)\n          .fromTo(cOf(\"1-logo\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 2.2)\n          setTimeout(function(){addContentLinks();}, 1000);\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Olympic Official Publication of the Olympic Movement  TM  REVIEW  June 2025 Number 124  A bright future As Thomas Bach hands over the IOC presidency to Kirsty Coventry, we look at how Olympic Agenda has shaped the Olympic Movement for the future  How Olympic Agenda has empowered athletes across the Olympic Movement The IOC Refugee Olympic team is impacting sport at all levels Kirsty Coventry: from childhood in Zimbabwe to the IOC presidency  olympics.com"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 4-title\" style=\"top:111px;left:42px;\" src=\"/124/static/_content/4-title-1.png\"/>\n\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(6);\" style=\"top:356px; left:50px; width:78px; height:91px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(8);\" style=\"top:309px; left:341px; width:148px; height:121px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(18);\" style=\"top:330px; left:516px; width:118px; height:101px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(16);\" style=\"top:515px; left:213px; width:120px; height:121px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(38);\" style=\"top:726px; left:424px; width:240px; height:110px;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim.fromTo(cOf(\"4-title\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(34);\" style=\"top:164px; left:204px; width:96px; height:110px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(50);\" style=\"top:341px; left:75px; width:134px; height:110px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(60);\" style=\"top:246px; left:350px; width:124px; height:96px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(70);\" style=\"top:559px; left:324px; width:113px; height:96px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(78);\" style=\"top:726px; left:50px; width:72px; height:108px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(80);\" style=\"top:726px; left:152px; width:99px; height:108px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(82);\" style=\"top:726px; left:270px; width:77px; height:108px;\"></div>\n\n        <div class=\"addContentLink\" style=\"top:608px;left:521px;width:101px;height:8px\">\n          <a href=\"https://olympics.com/ioc\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:616px;left:521px;width:105px;height:8px\">\n          <a href=\"mailto:olympicreview@olympic.org\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Olympic Review  5  Issue 124  FEATURES EXECUTIVE BOARD President Thomas Bach President-Elect Kirsty Coventry Vice-Presidents Juan Antonio Samaranch, Nawal El Moutawakel, Gerardo Werthein, Baron Pierre-Olivier Beckers-Vieujant Members Nenad Lalovic, Ivo Ferriani, HRH Prince Feisal Al Hussein, Mikaela Cojuangco Jaworski, Lingwei Li, Emma Terho, Spyros Capralos, Kristin Kloster, Octavian Morariu  34  IOC PRESIDENT-ELECT  Kirsty Coventry was elected the 10th IOC President at the 144th IOC Session.  60  ATHLETE SAFEGUARDING  How the IOC has embedded safeguarding across the Olympic Movement.  50  ATHLETES AT THE HEART  IMAGES  IOC REFUGEE OLYMPIC TEAM  From its Olympic Games debut to having an impact across all levels of sport.  78  80  82  Book reviews from the IOC Olympic Studies Centre.  Olympians and figures from the Olympic Movement who have passed away.  Ten key highlights from the Olympic Agenda reforms.  THE LAST WORD  Cover image: IOC/Greg Martin Inside: IOC; IOC/Greg Martin; IOC/ Christophe Moratal; IOC/Lisa Maree Williams; IOC/Arnaud Meylan; IOC/Richard Juilliart; IOC/Ian Jones; IOC/Rakuto Makino; IOC/Ubald Rutar; IOC/John Huet; IOC/John Gichigi; IOC/António Ferreira; IOC/Adam Mork; IOC/Albert Riethausen; IOC/David Burnett; IOC/Mine Kasapoglu; IOC/Nelson Chavez; IOC/Benoît Fontaine; IOC/Kishimoto; IOC/Stephen Munday; Getty Images; Paris 2024 Organising Committee for the Olympic and Paralympic Games; LA28 Organising Committee for the Olympic and Paralympic Games; Alexandre Loureiro/COB; Visit Salt Lake; DPA; National Olympic Committee of Zambia; ORF/AVSI; Shutterstock; Panasonic  CONTACTS Please contact us at: Olympic Review, IOC Corporate Communications & Public Affairs Department, Maison Olympique, 1007 Lausanne, Switzerland website: www.olympics.com/ioc email: olympicreview@olympic.org tel: +41 (0)21 621 6111 Olympic Review uses PEFC-certified paper stock sourced from sustainably managed forests. Olympic Review is published by the International Olympic Committee. The articles published in Olympic Review do not necessarily reflect the opinions of the International Olympic Committee. No articles may be reproduced without the permission of the IOC Corporate Communications & Public Affairs Department. The Olympic terminology (in particular Olympic™, Olympics™ and Olympic Games™) and other Olympic Properties are registered trademarks (TM) owned by the IOC. For further information on the protection of the Olympic Properties, please consult the website: olympics.com.  All information correct at the time of going to press  70  OBITUARIES  Corporate Communications & Public Affairs Director Christian Klaue Editor-in-Chief Katharine Mann Deputy Editor & French Edition Lucile Tonnerre Spanish Edition Dolores Blázquez Production Agency Touchline Production Michael Stoneman, Glyn Wilmshurst, John Murray, Sam Price, Conor Ketley Design Liz Rankin, Shyama Rajani, Apostolis Tatasopoulos, Jen Thich Image retouching Liz Rankin Translation Aurélien Sagnier, Héctor Lopez Conceiro Proofreading Cameron Harvey-Piper, Will Fulford-Jones ISSN: 0377-192X Printed in the UK  Athlete representation across the Olympic Movement has grown significantly over the past decade.  OLYMPIC STUDIES  OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 6-title\" style=\"top:175px;left:42px;\" src=\"/124/static/_content/6-title-1.png\"/>\n\n        <div class=\"addContentLink abs\" style=\"top:382px; left:343px; width:104px; height:13px;\">\n          <a href=\"https://olympics.com/ioc/olympic-agenda-2020\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg6Anim = new TimelineMax();\n          pg6Anim.fromTo(cOf(\"6-title\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg6Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "6  Foreword  FOREWORD BY THOMAS BACH T  1 The Olympic Agenda reforms have placed athletes at the heart of the Olympic Movement – heptathletes celebrate at Paris 2024.  his edition of Olympic Review marks a special moment for all of us who have walked this Olympic journey together over the past decade. When we launched Olympic Agenda 2020 in 2014, we were responding to a rapidly changing world. We recognised that to stay true to our mission, we had to change – or be changed. With openness as our guiding principle, we set out not simply to adjust procedures, but to transform the Olympic Movement for a new era: more inclusive, more sustainable, more credible and ever more focused on the athletes who are the beating heart of our Olympic Movement. This was never a journey of one person or one institution. From the very beginning, Olympic Agenda has been deﬁned by a spirit of unity in diversity. The reforms were shaped by an unprecedented consultation process – drawing on the ideas, voices and passion of athletes, IOC Members, National Olympic Committees, International Federations and people from all walks of life. The result was not just a roadmap for the future, but a shared commitment to live up to the values that make our Movement a force for good in the world. This edition of Olympic Review offers a moment to look back on all that we have achieved together with our Olympic Agenda, reﬂecting on the journey of over a decade of reform. From thoughtful reﬂections to personal tributes, this issue captures the essence of our collective efforts: staying true to our values, putting athletes ﬁrst and opening our  1  doors ever wider to the world. It is a reminder that every milestone we reached was made possible by working together – and that this spirit of togetherness will continue to guide the Olympic Movement into the future. As I reﬂect on this journey, I do so with a deep sense of gratitude – to all those who walked this path together. Our unity in diversity has been the deﬁning strength of the Olympic Movement during these years of transformation and change. As my presidency comes to an end, I look to the future of our Olympic Movement with full conﬁdence because I know it will be in good hands. The IOC President-elect Kirsty Coventry is deeply anchored in the"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n        <div id=\"7-sig\" class=\"abs noOverflow\" style=\"top:775px; left:465px; height:42px; width:168px; background-color:#ffffff\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg7Anim = new TimelineMax();\n          pg7Anim.fromTo(idOf(\"7-sig\"), 0.8, {width:155,x:0}, {width: 0,x:167, ease: Power2.easeOut}, 1.1)\n        }\n\n      function onPageLeave() {\n        pg7Anim.stop();\n        }\n      ",
    "searchText": "Olympic Review  7  Issue 124  “Our unity in diversity has been the deﬁning strength of the Olympic Movement during these years” Olympic values. Throughout her remarkable career – as a two-time Olympic champion, a long-time athlete representative, Chair of the IOC Athletes’ Commission, a sports minister and an IOC Executive Board member – she has consistently embodied these values, both professionally and personally. Her election is a testament to the trust and respect she has earned across our global community. What is  more, as the ﬁrst woman and the ﬁrst African to be elected IOC President, she embodies the universality of our Olympic Movement and the global relevance of the IOC. Now that the time has come to pass the torch to a new generation of leadership, I want to express my deep gratitude to everyone in our worldwide Olympic community. It is thanks to the support of so many around the globe that our Olympic Movement continues to reach new heights. Because of all we have achieved – and how we have achieved it, by always putting our values ﬁrst – we can look to the future with great conﬁdence. And we can look to this bright future knowing  that the strong foundation that we have built together will allow the Olympic Movement to keep growing, evolving and inspiring – always staying true to our values. This is the strength of our unity in diversity. In this Olympic spirit, let us continue to live our Olympic motto: Faster, Higher, Stronger – Together. ■  Thomas Bach, IOC President"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 8-title\" style=\"top:39px;left:245px;\" src=\"/124/static/_content/8-title-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax();\n          pg8Anim.fromTo(cOf(\"8-title\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg8Anim.stop();\n        }\n      ",
    "searchText": "OLYMPIC AGENDA"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 9-title\" style=\"top:292px;left:85px;\" src=\"/124/static/_content/9-title-1.png\"/>\n        <img class=\"abs halfScale 9-caption\" style=\"top:343px;left:84px;\" src=\"/124/static/_content/9-caption-1.png\"/>\n        <img class=\"abs halfScale 9-caption\" style=\"top:448px;left:84px;\" src=\"/124/static/_content/9-caption-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {  \n          pg9Anim = new TimelineMax();\n          pg9Anim.fromTo(cOf(\"9-title\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n          .staggerFromTo(cOf(\"9-caption\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.4)\n        }\n\n        function onPageLeave() {\n          pg9Anim.stop();\n        }\n      ",
    "searchText": "GUIDING THE IOC THROUGH CRISIS AND REFORM AS THE 12-YEAR TERM OF IOC PRESIDENT THOMAS BACH COMES TO AN END, THE OLYMPIC AGENDA REFORMS HAVE HELPED PUT THE IOC AND THE OLYMPIC MOVEMENT IN A STRONG PLACE FOR THE FUTURE. BY STEVE WILSON Paris 2024 was the ﬁrst Olympic Games that fully embodied the Olympic Agenda reforms."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "10  Cover feature: Olympic Agenda  A  shocking doping scandal. A global pandemic. An unprecedented Olympic postponement. A devastating war in Europe. These were just some of the challenges facing the International Olympic Committee (IOC) and wider Olympic Movement during Thomas Bach’s 12-year term as IOC President. “Ahead of every edition of the Olympic Games during my presidency, there were serious or even existential crises,” President Bach said. Yet despite all the turmoil, the IOC – guided by the motto “Change or be changed’’ – adapted and thrived. In a world fraught with conflict and division, the Olympic Games emerged even stronger as President Bach prepared to pass the leadership torch to President-elect Kirsty Coventry. Revelling in the dazzling success of the Olympic Games Paris 2024, the IOC President could take pride in the solid foundation he was leaving for the IOC: Olympic hosts secured until 2034; multiple candidates interested in the Games of 2036 and beyond; billions of dollars of revenues guaranteed for the next decade. President Bach credits many of the achievements to the Olympic Agenda reform programmes, which helped the  1  IOC navigate crises, shaped his presidency and will be remembered as a central pillar of his legacy. The process began with the adoption of Olympic Agenda 2020 in December 2014 at the 127th IOC Session in Monaco. Just a year into Bach’s presidency, IOC Members approved all 40 recommendations unanimously. “We could already see on the horizon the challenges we would be facing,” President Bach said. “We could see that if we did not proactively address these challenges our Olympic Movement would be hard hit by them.” The roadmap was updated in March 2021 with Olympic Agenda 2020+5, introducing 15 additional recommendations. The reforms came full circle at the Olympic Games Paris 2024, helping restore the Games to their full glory after the pandemic-impacted editions in Tokyo and Beijing. “In Paris we have seen our Olympic Agenda come to life,” President Bach told the 144th IOC Session in Costa Navarino, Greece, in March. “In many ways the Olympic Games Paris 2024 represent the culmination of our long journey together. “We set in motion the most far-reaching reform programme of our Olympic  Movement, at least in recent history. We embarked on a journey of change. It was a journey of collaboration, modernisation and determination.”  2  1 The Olympic Games Tokyo 2020 were safely held in 2021 following a one-year postponement due to the global pandemic. 2 The following year, the IOC successfully staged the Olympic Winter Games Beijing 2022. 3 Milano Cortina 2026 will stage the next Games, with a further four future hosts already conﬁrmed. 4 Excitement is growing for Los Angeles 2028."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 11-quote\" style=\"top:730px;left:43px;\" src=\"/124/static/_content/11-quote-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n        page11Anim = new TimelineMax();\n        page11Anim.fromTo(cOf(\"11-quote\"), 0.6, {opacity:0, y:10}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n        page11Anim.stop();\n        }\n      ",
    "searchText": "Olympic Review  11  Issue 124  Game changer Under Bach’s presidency, the IOC revolutionised the way the Olympic Games are awarded, organised and presented to the world. At a time when fewer and fewer cities were willing to host the Olympic Games due to concerns over rising costs, the IOC overhauled the bidding and selection process to make the Games more affordable and desirable. Rather than a competitive system that often produced “too many losers”, as the IOC President described it, the IOC shifted to a dialogue-based approach. The Future Host Commissions now work discreetly with interested candidates before selecting preferred hosts. The change reduced the risk of corruption, eliminated costly bid campaigns and cut the average cost of applying by 80 per cent. Potential hosts weren’t rejected – they could remain in dialogue for future Olympic Games. Just as importantly, hosting requirements were simplified to reduce costs and make the Games more sustainable. The IOC encouraged cities to use existing or temporary venues – even those located in other countries – while prioritising projects with clear legacy plans. No more exorbitant spending on fancy new venues. No more “white elephants”. No more budget blowouts. For an organisation that had faced serious uncertainty over securing Olympic hosts, the IOC could now rest easy knowing that Games were locked in for the next decade at least. While most IOC Presidents leave office with three future Games in place, Bach departs with five – Milano Cortina 2026, Los Angeles 2028, French Alps 2030, Brisbane 2032 and Salt Lake City-Utah 2034. In addition, Switzerland has been invited into a “privileged dialogue” for the Olympic Winter Games of 2038, while the number of cities interested in hosting the Games of 2036 and beyond is in double figures.  “The interest in hosting the Olympic Games has never been so high. This is a clear sign of the success of our reforms” IOC PRESIDENT THOMAS BACH  3  4  “The interest in hosting the Olympic Games has never been so high,” President Bach said. “This is a clear sign of the success of our reforms.”  Coping with Covid Perhaps the greatest challenge faced by the IOC during Bach’s presidency was the Covid-19 pandemic, which led to the unprecedented one-year postponement of the Olympic Games Tokyo 2020. “We were in uncharted territory,” President Bach said. “There was no blueprint. We had to take daily decisions on very uncertain grounds. We had doubts every day. We deliberated and we discussed. There were sleepless nights. Like everyone else in the world, we did  not know – I did not know – what the future would hold.” Through extensive consultations with Olympic stakeholders and its Executive Board, the IOC worked with the Japanese government and Tokyo 2020 organisers, first to postpone the Games and then to organise them in 2021 under strict health protocols and without spectators in the stands. “Today, I can admit how much this weighed on me,” President Bach said. “But it always helped me to know that we all together agreed that we had to make the Olympic Games happen. We had to make them happen for the athletes. “We stood together in good times – that is easy. But what is more important: we stood together in challenging times.”"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 12-quote\" style=\"top:730px;left:469px;\" src=\"/124/static/_content/12-quote-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n        page12Anim = new TimelineMax();\n        page12Anim.fromTo(cOf(\"12-quote\"), 0.6, {opacity:0, y:10}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n        page12Anim.stop();\n        }\n      ",
    "searchText": "12  Cover feature: Olympic Agenda  the Opening Ceremony was held outside a stadium on the River Seine. Sustainability was also at the forefront, with Paris 2024’s carbon footprint reduced by 50 per cent compared with the average emissions of London 2012 and Rio 2016. Beyond the facts and figures, Paris 2024 carried a larger significance. “In our fragmented world, with the far too many wars, conflicts and divisions tearing us apart, people everywhere were longing for something that is unifying, for something that gives us hope,” President Bach said. “Paris 2024 came at the right time to meet these expectations.”  Financial success  violating the Olympic Truce and setting off the biggest military conflict in Europe since World War II. In response, the IOC recommended the exclusion of athletes from Russia and military ally Belarus from international sports events. In 2023, the IOC suspended the Russian Olympic Committee for incorporating sports organisations from occupied Ukrainian territories. In keeping with President Bach’s desire to ensure full universality at the Olympic Games, the IOC allowed a small number of Russian and Belarusian athletes to compete as “neutrals” at Paris 2024 without national symbols.  Despite global economic uncertainty, the IOC’s commercial revenue has grown by 60 per cent since 2012, securing over USD 30 billion in broadcast and sponsorship deals. Revenue from global media rights and Olympic Partner (TOP) sponsorships increased from USD 5.2 billion in 2013-2016 to USD 7.7 billion in 2021-2024. The IOC has already secured USD 7.5 billion for 2025-2028 and USD 6.9 billion for 2029-2032. Another USD 4 billion is already in hand for 2033-2036. All told, that’s more than USD 18 billion guaranteed over the next 12 years. The IOC has been particularly active in the final months of Bach’s presidency, sealing a TOP sponsorship deal with Chinese electronics firm TCL, extensions with AB InBev and Allianz, and a renewed USD 3 billion media rights agreement with Comcast NBCUniversal until 2036.  Merci Paris  New frontiers  For President Bach and the IOC, Paris 2024 was the Games that fully embodied the Olympic Agenda reforms. The IOC President described them as “Games of a new era – the youngest, most urban, most inclusive, most sustainable Olympic Games ever”. Paris was the first Olympic Games with full gender parity. The programme featured youth-focused sports such as breaking and skateboarding. The Games showcased iconic city backdrops such as the Eiffel Tower and Place de la Concorde. In a historic first,  Two new ground-breaking initiatives also marked the final stretch of President Bach’s term. The IOC launched the Olympic AI Agenda to harness the potential of artificial  1  Sochi scandal and war in Ukraine Bach’s presidency was also defined by his handling of Russia-related crises. The Olympic Winter Games Sochi 2014 – the first Games under Bach’s presidency – were marred by a Russian doping scandal that included the switching of tainted urine samples for clean ones through a small hole drilled in the wall of the anti-doping laboratory. Further investigations uncovered a massive statebacked conspiracy involving hundreds of Russian athletes across dozens of sports. President Bach said: “One of the things I would like to know but I don’t think that the Kremlin will ever reveal is this: ‘Who knew what and who did what?’” In the meantime, the IOC bolstered measures to catch drug cheats and protect clean athletes. The IOC created the International Testing Agency in 2018 to implement independent anti-doping programmes for International Federations and to manage the testing at the Olympic Games. It also launched long-term storage of Olympic doping samples for reanalysis. As part of its 50 per cent funding of the World Anti-Doping Agency’s (WADA) budget, the IOC contributed around USD 20 million in 2024. The IOC also invested an additional USD 15 million to support WADA’s research, intelligence and investigation work. Shortly after the Olympic Winter Games Beijing 2022, Russia invaded Ukraine,  1 The Olympic AI Agenda considers the impact that artiﬁcial intelligence can deliver for sport.  “We stood together in good times – that is easy. But what is more important: we stood together in challenging times” IOC PRESIDENT THOMAS BACH"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top:830px;left:553px;width:123px;height:17px\">\n          <a href=\"https://www.samsung.com/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "intelligence (AI) in sport, including a pilot talent-identification project in Senegal. AI was also deployed to protect athletes from online abuse at Paris 2024. In a move to connect with younger audiences, the IOC established the Olympic Esports Games in a 12-year partnership with the Saudi Olympic and Paralympic Committee. The inaugural event will take place in Riyadh in 2027.  Giving back At the IOC Session in Greece, IOC Members paid long tributes to President Bach and elected him Honorary President for life. Receiving a standing ovation, an emotional Bach reflected on what the journey had meant to him. “I am grateful that after my career as [an] athlete, I could continue to live my passion for sport,” he said. “My gold medal in 1976 changed my life. As IOC President, I had the opportunity to help others change theirs. I have given to the Olympic Movement what I could give.” After 12 years in office, and having steered the IOC through crisis and transformation, President Bach could finally unwind. “I feel happy and relaxed,” he said. “And relieved.” ■  1  2  1 Revenue from TOP sponsorships and media rights increased to USD 7.7 billion in 2021-2024. 2 IOC Members pay tribute to President Bach at the 144th IOC Session."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "©2021: Marco Bertorello / Getty Images /All rights reserved  Excellence begins with a series of small actions. Visa is a proud partner of the Olympic and Paralympic Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 16-title\" style=\"top:155px;left:42px;\" src=\"/124/static/_content/16-title-1.png\"/>\n        <img class=\"abs halfScale 16-caption\" style=\"top:292px;left:43px;\" src=\"/124/static/_content/16-caption-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          page16Anim = new TimelineMax();\n          page16Anim.fromTo(cOf(\"16-title\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"16-caption\"), 0.6, {opacity:0, x:-50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n        }\n\n        function onPageLeave() {\n          page16Anim.stop();\n        }\n      ",
    "searchText": "16  Beyond the rings  BEYOND THE RINGS  Sport, health and the power of partnership Dr Tedros Adhanom Ghebreyesus, DirectorGeneral of the World Health Organization, looks at how the Olympic Movement has helped create healthier futures through the beneﬁts of physical activity  W  hen the Olympic flame was lit in Tokyo in 2021, it burned not only as a symbol of athletic excellence, but also as a beacon of resilience, hope and global solidarity. As the world grappled with the Covid-19 pandemic, the successful delivery of the Olympic Games Tokyo 2020 and Beijing 2022 offered more than competition; it showed that with strong  partnerships, careful planning and a shared commitment to health, the world could come together, even in its most challenging moments. The World Health Organization (WHO) was proud to stand alongside the International Olympic Committee (IOC) during this critical time. Our close collaboration with the IOC, Japanese and Chinese authorities, and international  1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  17  Issue 124  2  public health experts made it possible to host these Games safely. We collaboratively developed and implemented robust Covid-19 prevention and response measures that protected athletes, officials and communities, setting a global precedent for how major events could take place during a health crisis. Sport is a powerful enabler of health. It inspires movement, strengthens communities and uplifts the spirit. The Games held during the pandemic reminded us that sport promotes connection as well as physical and mental well-being, especially when movement was restricted and isolation widespread. Over the past several years, the IOC and WHO have worked hand in hand to leverage the power of sport in advancing global health. Our joint Let’s Move campaign, launched in 2023, calls on  1 Dr Tedros Adhanom Ghebreyesus (second from right) takes part in the Olympic Torch Relay at Paris 2024. 2 Receiving the Olympic Order in 2023 for recognition of his role in ensuring Tokyo 2020 took place.  people everywhere to embrace physical activity in their daily lives. Athletes have been at the forefront of this movement, motivating millions to take small steps towards better health. During the Olympic Games Paris 2024, we saw this vision come to life. Thanks to evidence from WHO on the health benefits of physical activity, the leadership of the IOC and France’s commitment to using sport as a tool for well-being, we witnessed a lasting legacy: the introduction of daily physical activity programmes in all French schools. It is a powerful example of how the Olympic Movement can drive policy change and thereby create healthier futures. To support these efforts more broadly, WHO launched the Sport for Health programme, which integrates health into all aspects of sport, from mega-events to grassroots participation. This includes promoting healthier food options, mental health, tobacco-free environments and stronger health security in sporting venues. Through this initiative, we work with host countries, sports federations and health partners to  make sport safer, healthier and more inclusive for everyone – from elite athletes to fans of all ages, volunteers and local communities. As we look back on the past 12 years of Olympic reform and leadership, I want to pay special tribute to Thomas Bach. First and foremost, Thomas is a great leader whose vision has shaped the Olympic Movement into a force for inclusion, sustainability and global good. But more than that, he is a true friend. In times of crisis, true friendships are revealed. The IOC’s partnership with WHO during the pandemic was a testament to the power of friendship, trust, teamwork and a shared purpose. On behalf of the World Health Organization, I thank Thomas for his steadfast commitment to health, and for always keeping people at the heart of the Olympic mission. I also extend my best wishes and support to new IOC President Kirsty Coventry, and look forward to WHO and the IOC building on the legacy of what we have achieved and taking our partnership to the next level for many years to come. ■  Born in the Eritrean city of Asmara, Dr Tedros Adhanom Ghebreyesus served in Ethiopia’s federal government for over a decade as Minister of Health and Minister of Foreign Affairs. In May 2017, he was was elected WHO Director-General, becoming the ﬁrst person from the WHO African Region to head the world’s leading public health agency."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 18-logo\" style=\"top:104px;left:239px;\" src=\"/124/static/_content/18-logo-1.png\"/>\n        <img class=\"abs halfScale 18-title\" style=\"top:308px;left:244px;\" src=\"/124/static/_content/18-title-1.png\"/>\n        <img class=\"abs halfScale 18-title\" style=\"top:399px;left:175px;\" src=\"/124/static/_content/18-title-2.png\"/>\n        <img class=\"abs halfScale 18-title\" style=\"top:489px;left:201px;\" src=\"/124/static/_content/18-title-3.png\"/>\n        <img class=\"abs halfScale 18-caption\" style=\"top:610px;left:191px;\" src=\"/124/static/_content/18-caption-1.png\"/>\n\n        <a href=\"https://www.youtube.com/watch?v=YgiDFGLquYc\" target=\"_blank\"><img class=\"halfScaleC halfpulse animatedpulse pointer z-index-set\" src=\"/124/static/_content/play-btn.png\" style=\"top:707px;left:323px;\" /></a>\n      ",
    "script": "\n        function onPageEnter() {\n          page18Anim = new TimelineMax();\n          page18Anim.fromTo(cOf(\"18-logo\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .staggerFromTo(cOf(\"18-title\"), 0.6, {opacity:0, x:100}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.1, 1.4)\n          .fromTo(cOf(\"18-caption\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.8)\n        }\n\n        function onPageLeave() {\n          page18Anim.stop();\n        }\n\n      ",
    "searchText": "UNITING THE OLYMPIC MOVEMENT  IN A SERIES OF INTERVIEWS RECORDED DURING PARIS 2024 AND AFTER, FIGURES FROM THE OLYMPIC MOVEMENT AND BEYOND SHARED THEIR VIEWS ON THE IMPACT OF THE OLYMPIC AGENDA REFORMS. EXCERPTS FROM THESE INTERVIEWS CAN BE READ IN THE FOLLOWING PAGES"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 19-icon\" style=\"top:99px;left:42px;\" src=\"/124/static/_content/19-icon-1.png\"/>\n        <img class=\"abs halfScale 19-caption\" style=\"top:137px;left:129px;\" src=\"/124/static/_content/19-caption-1.png\"/>\n        <img class=\"abs halfScaleC 19-icon\" style=\"top:599px;left:402px;\" src=\"/124/static/_content/19-icon-2.png\"/>\n        <img class=\"abs halfScale 19-caption\" style=\"top:637px;left:486px;\" src=\"/124/static/_content/19-caption-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          page19Anim = new TimelineMax();\n          page19Anim.staggerFromTo(cOf(\"19-icon\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  0.1, 1.8)\n          .staggerFromTo(cOf(\"19-caption\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.1, 1.9)\n        }\n\n        function onPageLeave() {\n          page19Anim.stop();\n        }\n      ",
    "searchText": "Olympic Review  19  Issue 124  Emmanuel Macron President of France  I think I can say that Thomas has gradually become a friend whom I trust and respect greatly. I think that he has contributed greatly to modernising and transforming the IOC and the Olympic Movement, ﬁrstly by constantly pushing for reinvention and for new events, but also by pushing everyone to ensure that the Olympic Games reconnect with their audience and with young people … He has served Olympism as an athlete and later as a professional, as a lawyer and as the IOC President, so I hold him in high regard. I think that the IOC is lucky to have been led by him for all these years and that he was right to want to keep modernising, transforming and opening up the IOC. I wish the IOC every success. Thanks to Thomas Bach, Paris 2024 was the ﬁrst gender-equal Games. Together, we’ve made the Paralympic Games a continuation of the Olympic Games. Together, we’ve created the most sustainable Games ever. Olympism is tackling contemporary challenges, be it gender equality, the climate or sustainable development. To this, we can add gaming, esports, AI and digital technology – all challenges that the Olympic Movement needs to address. The road ahead  has been mapped out, and the wise man, if I may say so, has deﬁned it. I hope that he continues to build a legacy as bold, as wise and as innovative. France certainly owes Thomas Bach a lot for the years that we’ve spent together. I’d like to extend to him my very sincere thanks as President and as a friend.  Brian L. Roberts  Comcast Chair and CEO  In Paris, we showed the world harmony. We showed the world a fantastic competition, but also the coming together of humanity in a way to support each other and use technology to our good, not just [for] controversy... the broadcasting and the streaming and the celebrity and the knowledge and the technology but, most of all, just the partnership between the International Olympic Committee and Comcast NBCUniversal reached its pinnacle."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 20-icon-1\" style=\"top:327px;left:17px;\" src=\"/124/static/_content/20-icon-1.png\"/>\n        <img class=\"abs halfScale 20-caption-1\" style=\"top:359px;left:103px;\" src=\"/124/static/_content/20-caption-1.png\"/>\n        <img class=\"abs halfScaleC 20-icon-2\" style=\"top:605px;left:-3px;\" src=\"/124/static/_content/20-icon-2.png\"/>\n        <img class=\"abs halfScale 20-caption-2\" style=\"top:651px;left:147px;\" src=\"/124/static/_content/20-caption-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          page20Anim = new TimelineMax();\n          page20Anim.fromTo(cOf(\"20-icon-1\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  1)\n          .fromTo(cOf(\"20-caption-1\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.1)\n          .fromTo(cOf(\"20-icon-2\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  1.3)\n          .fromTo(cOf(\"20-caption-2\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)\n        }\n\n        function onPageLeave() {\n          page20Anim.stop();\n        }\n      ",
    "searchText": "20  Feature: Testimonials  Eileen Gu  Two-time Winter Olympic gold medallist The Olympics are evolving with our world as we get younger and more digital. We can see events like breakdancing and skateboarding that make us really excited and feel new and experiential. President Bach was right next to me as I received my score at the bottom of my Beijing [2022] big air [jump]. And in that moment, as I made history as the youngest freeski Olympic gold medallist, I remember the words that he had spoken at the Opening Ceremony, which had really touched me. I remember almost being brought to tears when I heard how his mission [for] the Olympics aligned with my own values.  He spoke about using sport to bring people together, about uniting people regardless of culture, age or gender, and instead using the power of sport to bring communication and unity to people. The way he said that was really inspiring. So at the very bottom of my Beijing big air jump, I told him that. And that was a really exciting moment, I think, for both of us. [President] Bach has an eye towards the future, and that's something that I admire a lot.  Dr Valérie Fourneyron  International Testing Agency Board Chair The Olympic spirit is what has been instilled during President Bach’s mandate, thanks to his total dedication to the Olympic Movement and his thirst for the reform that is indispensable to the Movement’s future. Protecting clean athletes means protecting sport. It means protecting athletes’ health. If you stop believing in the authenticity of a result, you stop believing in sport. So, to make sure that we can keep honouring athletes’ performances, we need to ﬁght unwaveringly to protect those clean athletes. At the start of his mandate, President Bach announced that he wanted  Sustainability, and especially using the Olympic platform to promote sustainability, has been a really inspiring thing that President Bach has been doing, and that I respect a lot as a winter sports athlete.  to give clean athletes stronger protection. He wrote that aim into Olympic Agenda 2020 but, above all, he kept his promise with the creation of the International Testing Agency (ITA). So, he needed to be bold enough to leave the anti-doping programme to the ITA, and he was. He needed to show that the Olympic Movement was taking that responsibility and that it wanted to avoid a potential conﬂict of interest. We all need to have President Bach’s unwavering desire to develop and strengthen the ﬁght against doping. Across all of the reforms that have been brought about under President Bach, I think that the International Testing Agency… will remain a key step and a legacy, and that legacy is to serve clean athletes."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 21-icon-1\" style=\"top:86px;left:1px;\" src=\"/124/static/_content/21-icon-1.png\"/>\n        <img class=\"abs halfScale 21-caption-1\" style=\"top:226px;left:43px;\" src=\"/124/static/_content/21-caption-1.png\"/>\n        <img class=\"abs halfScaleC 21-icon-2\" style=\"top:86px;left:473px;\" src=\"/124/static/_content/21-icon-2.png\"/>\n        <img class=\"abs halfScale 21-caption-2\" style=\"top:226px;left:515px;\" src=\"/124/static/_content/21-caption-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          page21Anim = new TimelineMax();\n          page21Anim.fromTo(cOf(\"21-icon-1\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  1.1)\n          .fromTo(cOf(\"21-caption-1\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n          .fromTo(cOf(\"21-icon-2\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  1.2)\n          .fromTo(cOf(\"21-caption-2\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n        }\n\n        function onPageLeave() {\n          page21Anim.stop();\n        }\n      ",
    "searchText": "Olympic Review  21  Issue 124  Francesco Ricci Bitti  Alexandra de Navacelle de Coubertin  IOC Honour Member  It was very important [for the IOC to conduct a consultation process around Olympic Agenda 2020] because it was ﬁtting with the vision of Thomas Bach that the IOC, the Olympic Movement, has to evolve. [From] the perspective of the International Federations, I will say that [these reforms] have had a direct impact on the Games. First, the simpliﬁcation of the bid procedure was very important; the second was the role of the International Federations in delivering the Games, including all the optimisation measures that came with this; and third, last but not least, the ﬁrst-time emphasis and attention on sustainability and legacy.  Outside the Games... in general, we [have] witnessed… the growing relevance of sport in society and the extension of the mission that [Olympic] Agenda [2020] allowed. The Olympic Movement has been vital for this new role of sport in society. Thomas, in my opinion, will be remembered as a very great President for two reasons. One, the Games of Tokyo and Beijing during the pandemic time. Without his resilience, I would think [these] Games would never [have] happened. And the second one, in general, he allows, through Agenda 2020, the IOC to extend its mission to be a very important player in society.  Pierre de Coubertin Family Association President  I’d like to extend my gratitude to Thomas Bach who is, quite honestly, one of the most inspiring ﬁgures of the Olympic Movement that I’ve ever seen. His measures are always thought through, and there’s detachment in the way [he approaches] sometimes complicated situations, especially in wars, [or during] the pandemic. I think he did an incredible job, giving messages to the world, keeping the Games in Tokyo because it was important to stay in motion and do whatever we could, given, naturally, the circumstances. The Olympic motto – ‘Faster, Higher, Stronger – Together’ – is a clear message, and having ‘Together’ added was brilliant because it really encapsulates the spirit in that one word. In a way, it was always there, but it wasn’t truly explicit."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 22-icon-1\" style=\"top:326px;left:18px;\" src=\"/124/static/_content/22-icon-1.png\"/>\n        <img class=\"abs halfScale 22-caption-1\" style=\"top:363px;left:106px;\" src=\"/124/static/_content/22-caption-1.png\"/>\n        <img class=\"abs halfScaleC 22-icon-2\" style=\"top:612px;left:1px;\" src=\"/124/static/_content/22-icon-2.png\"/>\n        <img class=\"abs halfScale 22-caption-2\" style=\"top:751px;left:42px;\" src=\"/124/static/_content/22-caption-2.png\"/>\n        <img class=\"abs halfScaleC 22-icon-3\" style=\"top:60px;left:445px;\" src=\"/124/static/_content/22-icon-3.png\"/>\n        <img class=\"abs halfScale 22-caption-3\" style=\"top:210px;left:490px;\" src=\"/124/static/_content/22-caption-3.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          page22Anim = new TimelineMax();\n          page22Anim.fromTo(cOf(\"22-icon-1\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  1)\n          .fromTo(cOf(\"22-caption-1\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.1)\n          .fromTo(cOf(\"22-icon-2\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  1.3)\n          .fromTo(cOf(\"22-caption-2\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)\n          .fromTo(cOf(\"22-icon-3\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  1.1)\n          .fromTo(cOf(\"22-caption-3\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n        }\n\n        function onPageLeave() {\n          page22Anim.stop();\n        }\n      ",
    "searchText": "Gene Sykes  IOC Member; USOPC President  Filippo Grandi  United Nations High Commissioner for Refugees We’ve been cooperating with the International Olympic Committee on sports projects in [a] refugee context for decades but, particularly in the last few years since the Rio Olympics, this cooperation has grown enormously – ﬁrst through the launch by the IOC of this fantastic initiative, the Refugee Olympic Team, that [saw] its third edition in Paris with 37 athletes. But then also with the establishment of the Olympic Refuge Foundation, of which the President of the IOC is the President and I’m the Vice-President, and which  Witold Bańka WADA President  allows us to work together throughout the world, with the funding of generous donors, to promote sports as a vehicle for inclusion, for achievement, for mental health, and many, many other advantages that sports brings to situations of fragility and displacement. Social inclusion in refugee contexts is often one of the main challenges. And we have seen that sport has been a way to overcome some of the difficulties. Sport is a fantastic tool to improve the lives of refugees and to give them hope and a better future.  I think Olympic Agenda is an extremely important document for the future of sports, structuring the procedures, the rules in sports. The collaboration with different entities and stakeholders is very important, and a part of Olympic Agenda is an anti-doping policy and strong collaboration with WADA. [President Bach] thinks that anti-doping plays a very important role in the sporting landscape. So as WADA, we feel this support and together we can do more. This is the essence of the IOC’s vision – the collaboration. And I really welcome this approach. I'm very happy that, thanks to this collaboration and strong support from the IOC, we can be stronger. We can work even more effectively for the athletes.  It was clear to us how much the IOC was dedicated to these reforms. We heard a lot about sustainability, simplicity, reuse. And actually, I must say, I give credit to the IOC and Agenda 2020 for making the LA [2028] bid possible. And I say that because without the direction that the IOC would actually support the idea of reusing existing infrastructure and allow us to consider having university residences operate as an Olympic Village, I don’t know that we could have afforded to build a brand new Olympic Village, [or] that it would have worked in Los Angeles. I think the President and all of the IOC understand that the Games only work to the extent that they’re truly popular. And popularity is, if you will, always demographically challenged by new experiences that young people have. Young people seek out areas where they can interact with each other, use technology, learn from experience, which is richer and more fulﬁlling, more gratifying. The Games, to some degree, have to keep up with where the young people are. And in many cases, that’s in sports – or there are manifestations in sports that we can think of that work very well in the Olympic Movement. So, the introduction of several of the new urban-style sports or sports that are more youth-oriented is very valuable."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 23-icon-1\" style=\"top:87px;left:49px;\" src=\"/124/static/_content/23-icon-1.png\"/>\n        <img class=\"abs halfScale 23-caption-1\" style=\"top:118px;left:136px;\" src=\"/124/static/_content/23-caption-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          page23Anim = new TimelineMax();\n          page23Anim.fromTo(cOf(\"23-icon-1\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  1.2)\n          .fromTo(cOf(\"23-caption-1\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n        }\n\n        function onPageLeave() {\n          page23Anim.stop();\n        }\n      ",
    "searchText": "Olympic Review  23  Issue 124  Nicole Hoevertsz Former IOC VicePresident; Olympian  Olympic Agenda is a labour of collaboration. It’s a labour of unifying the Olympic Movement, of everybody around the world who wanted to have something to say about the organisation and how they view the organisation moving forward. Everybody had the opportunity to bring an opinion forward. [Olympic Agenda 2020] was really implemented in practice. And in order to do that, the IOC President created an organisation, an administration, staff that really was  dedicated, and that really worked very hard in making sure that the Olympic Agenda recommendations actually became reality. Olympic Agenda was not just something that we included in our sentences and in our discussions. It really became part of who we are and what we wanted to accomplish. I think the Members really understood what the recommendations represented, what they meant and what we wanted to accomplish with them. So the Members really had a very important say in that. I’m a champion for gender equality. Women in sports is very dear to my heart.  It made me very proud to see that, in Paris 2024, we [had] the ﬁrst-ever Olympic Games where we celebrated gender equality in the participation of athletes. We still have a long way to go. We still need more women coaches in the Olympic Movement. We’re developing important and interesting projects to accomplish that in the years ahead. We have more women than ever before as presidents of commissions; members of commissions have reached that parity as well. So, we are moving forward very, very fast. We have younger women also as IOC Members, through the Athletes’ Commission. We have more women directors nowadays. So, we’re doing a lot to have more women included in all aspects of the Olympic Movement. I ﬁnd it very special that the International Olympic Committee is a permanent observer at the United Nations, and it gives us leverage. It gives us access to many of the agencies of the UN, with which we have an excellent working relationship. UNHCR has been in the forefront the last couple of years because of the fact that we work so closely for the refugee delegation and need the collaboration of UNHCR. I think it’s very important also to recognise that the IOC, with all the knowledge it has, with all these international events, but also of course the Olympic Games, brings a wealth of expertise and knowledge and experience to the table from which these international organisations can beneﬁt. [President Bach] has come up with very challenging initiatives and has steered the organisation through very challenging times. Of course, we recognise the pandemic, but let’s not forget the doping crisis and all these different, difficult periods that the President has led us through in a very positive way and with a good result for the IOC."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 24-icon-1\" style=\"top:52px;left:426px;\" src=\"/124/static/_content/24-icon-1.png\"/>\n        <img class=\"abs halfScale 24-caption-1\" style=\"top:192px;left:468px;\" src=\"/124/static/_content/24-caption-1.png\"/>\n        <img class=\"abs halfScaleC 24-icon-2\" style=\"top:541px;left:39px;\" src=\"/124/static/_content/24-icon-2.png\"/>\n        <img class=\"abs halfScale 24-caption-2\" style=\"top:630px;left:66px;\" src=\"/124/static/_content/24-caption-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          page24Anim = new TimelineMax();\n          page24Anim.fromTo(cOf(\"24-icon-1\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  1)\n          .fromTo(cOf(\"24-caption-1\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.1)\n          .fromTo(cOf(\"24-icon-2\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  1.4)\n          .fromTo(cOf(\"24-caption-2\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.5)\n        }\n\n        function onPageLeave() {\n          page24Anim.stop();\n        }\n      ",
    "searchText": "24  Feature: Testimonials  Andrew Parsons  IOC Member; International Paralympic Committee President [The Olympic Agenda reforms meant a lot to the Paralympic Movement.] The Paralympic Games [understood] where we ﬁt in this whole ecosystem of the Olympic Movement, meaning not [just] the Games but the development of sport or para sport – to make the Games more rational, for example, from a spending point of view. All the reforms [took] the Paralympic Movement into account, and this was really important to us. We were part of the discussions. We were part of the solutions – we needed to adapt [like] any other organisation. Because of those reforms, we are still – and probably more – relevant than ever before. The reforms [position] the IOC, the IPC, the sports movement as a partner of governments, as a partner of the OCOGs (Organising Committees). When we are doing these things together, one strengthens the other. The IOC strengthens the IPC.  Nadia Comaneci  IOC Athletes’ Entourage Commission member; ﬁve-time Olympic gold medallist We go back to 1976. We competed together in the same Olympic Games. And what we share together is sports and the respect for sports. I have seen a lot of changes and implementations that Thomas Bach has done. He cares a lot about the athletes. I don’t say others didn’t, but it's just like it’s a different way to accomplish things – to be able to help the underserved who have no possibilities."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 25-icon-1\" style=\"top:68px;left:32px;\" src=\"/124/static/_content/25-icon-1.png\"/>\n        <img class=\"abs halfScale 25-caption-1\" style=\"top:102px;left:119px;\" src=\"/124/static/_content/25-caption-1.png\"/>\n        <img class=\"abs halfScaleC 25-icon-2\" style=\"top:53px;left:446px;\" src=\"/124/static/_content/25-icon-2.png\"/>\n        <img class=\"abs halfScale 25-caption-2\" style=\"top:193px;left:488px;\" src=\"/124/static/_content/25-caption-2.png\"/>\n        <img class=\"abs halfScaleC 25-icon-3\" style=\"top:528px;left:446px;\" src=\"/124/static/_content/25-icon-3.png\"/>\n        <img class=\"abs halfScale 25-caption-3\" style=\"top:670px;left:489px;\" src=\"/124/static/_content/25-caption-3.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          page25Anim = new TimelineMax();\n          page25Anim.fromTo(cOf(\"25-icon-1\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  1.1)\n          .fromTo(cOf(\"25-caption-1\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n          .fromTo(cOf(\"25-icon-2\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  1.2)\n          .fromTo(cOf(\"25-caption-2\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n          .fromTo(cOf(\"25-icon-3\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  1.3)\n          .fromTo(cOf(\"25-caption-3\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)\n        }\n\n        function onPageLeave() {\n          page25Anim.stop();\n        }\n      ",
    "searchText": "Olympic Review  25  Issue 124  Tony Estanguet  IOC Member; Paris 2024 Organising Committee President; three-time Olympic gold medallist At Paris 2024, we were the ﬁrst Games – right from the bidding phase – to be guided by [Olympic] Agenda 2020. The acceptability of these Olympic Games was very important, as it was in an environmentally friendly setting – in terms of sustainability and carbon dioxide emissions. But they were also aligned with Agenda 2020 in terms of inclusion, much more respect, an even more open mind, so that everyone can have their place. They were more modern – especially with breaking, which was a new sport to appeal to young people and show them that the Olympic Games cover all sports, including those that are much more commonly watched and played by young people. So, we really tried to take everything into account and then we went into detail: to halve carbon emissions, we decided not to build any new buildings if they would be of no use  for the surrounding area. One hundred per cent public transport. We also had to use 100 per cent renewable electricity. Even with food, we doubled the amount of plant-based food. So, all these very detailed examples are part of the overarching goals of Agenda 2020, which were to become more eco-friendly, more inclusive and more modern. One of the big successes of Paris 2024 was that it was the ﬁrst-ever Games with gender parity. That's hugely symbolic... Having the Olympics promote women's sport and highlight the great female champions from every country with the same ambition as men, I think is a very strong message of inclusion and I’m convinced it will have an impact on the way girls and women play sports. I hope it will free people to play sports around the world, above all because it is beneﬁcial for society and for all humans to be able to play sport.  George Hirthler Author  I think history will see Thomas Bach as the most transformative President of the IOC. Thomas came in with a plan called [Olympic] Agenda 2020 – 40 principles for how to modernise, even more, contemporise, if you will, the Olympic Movement. In Paris, 10 years later we saw the results of that in an incredible, beautiful Olympic Games, in the most beautiful city in the world, with an urban setting that has never been produced at this level before. Agenda 2020 did something that is really miraculous. It presented a common vision, and a roadmap to the future, a blueprint for the way [forward] to reform and change this movement. Agenda 2020 became the platform that allowed the [IOC] Members to articulate the ways in which it should evolve, should change to become more relevant and meaningful in civil society.  Katarina Witt  Two-time Winter Olympic gold medallist Thomas Bach has been a great President for the Olympic Movement and a great leader in going [in] new directions. He really has a vision. And following this vision, and everybody [coming] together and believing in his vision, I think he has done a tremendous job for the Olympics."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 26-icon-1\" style=\"top:97px;left:41px;\" src=\"/124/static/_content/26-icon-1.png\"/>\n        <img class=\"abs halfScale 26-caption-1\" style=\"top:133px;left:126px;\" src=\"/124/static/_content/26-caption-1.png\"/>\n        <img class=\"abs halfScaleC 26-icon-2\" style=\"top:623px;left:-3px;\" src=\"/124/static/_content/26-icon-2.png\"/>\n        <img class=\"abs halfScale 26-caption-2\" style=\"top:674px;left:147px;\" src=\"/124/static/_content/26-caption-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          page26Anim = new TimelineMax();\n          page26Anim.fromTo(cOf(\"26-icon-1\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  1)\n          .fromTo(cOf(\"26-caption-1\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n          .fromTo(cOf(\"26-icon-2\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  1.3)\n          .fromTo(cOf(\"26-caption-2\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)\n        }\n\n        function onPageLeave() {\n          page26Anim.stop();\n        }\n      ",
    "searchText": "26  Feature: Testimonials  Ban Ki-moon  IOC Ethics Commission Chair; former United Nations Secretary-General When [the Republic of Korea] was hosting the Olympic Winter Games PyeongChang 2018, President Thomas Bach... invited the representatives of the boards of the South and North teams to Geneva, to sit down together to discuss this matter. They ﬁnally agreed to create the one team, South and North Korea, marching together  Gaby Ahrens  WADA Athlete Council Vice-Chair I [was] very proud to be at an Olympic Games where it [was] 50/50 [representation of male and female athletes]. I think it’s a human right for women and men to have the same rights, also the same obligations. And just to be part of this historic moment is already just such a great achievement in my eyes. Sport in itself really empowers women. It’s great for girls’ self-esteem. The Olympic  in the Opening Ceremony, under the Korean Peninsula ﬂag. That was the most moving moment for Koreans. They became one, even though they [had] different ideologies.  Games are a global platform. There are many different cultures in the world where it may not be 50/50 yet, so it’s a great encouragement and it’s a great movement. And I hope that in the very [near] future, this might be like this all over the world. For me, coming from Africa, I could really see how Thomas Bach has supported my continent, has supported women, has put a lot of women in leadership positions, which I’m really, really grateful for. And I think we need more leaders like this in the world."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 27-icon-1\" style=\"top:57px;left:-2px;\" src=\"/124/static/_content/27-icon-1.png\"/>\n        <img class=\"abs halfScale 27-caption-1\" style=\"top:195px;left:42px;\" src=\"/124/static/_content/27-caption-1.png\"/>\n        <img class=\"abs halfScaleC 27-icon-2\" style=\"top:425px;left:-1px;\" src=\"/124/static/_content/27-icon-2.png\"/>\n        <img class=\"abs halfScale 27-caption-2\" style=\"top:565px;left:43px;\" src=\"/124/static/_content/27-caption-2.png\"/>\n        <img class=\"abs halfScaleC 27-icon-3\" style=\"top:77px;left:245px;\" src=\"/124/static/_content/27-icon-3.png\"/>\n        <img class=\"abs halfScale 27-caption-3\" style=\"top:109px;left:329px;\" src=\"/124/static/_content/27-caption-3.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          page27Anim = new TimelineMax();\n          page27Anim.fromTo(cOf(\"27-icon-1\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  1.1)\n          .fromTo(cOf(\"27-caption-1\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n          .fromTo(cOf(\"27-icon-2\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  1.4)\n          .fromTo(cOf(\"27-caption-2\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.5)\n          .fromTo(cOf(\"27-icon-3\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  1.2)\n          .fromTo(cOf(\"27-caption-3\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n        }\n\n        function onPageLeave() {\n          page27Anim.stop();\n        }\n      ",
    "searchText": "Olympic Review  Issue 124  Cindy Ngamba  IOC Refugee Olympic Team member; Olympic bronze medallist  Jack Ma  Alibaba Group Co-founder [On ﬁrst meeting President Bach] Thomas talked a lot about uniting young people. And the other thing we [thought] is we all talk about [the] future. We all think about the future. We also think about how we can change [ourselves] to be better for the future. Both of us believe in [the] future, believe technology will enable us [and] will enable young people to create a better future. I think Thomas planted a very, very powerful and interesting hope for the future. And I admire that a lot.  Fraser Bullock  Salt Lake City-Utah 2034 Organising Committee President Olympic Agendas 2020 and 2020+5 set the roadmap for the future. That is so powerful. And we’ve seen it manifest in our Games, focused on partnership in the bid process, and in things like sustainability that are so important. [The candidature process has] gone from being competitive to being collaborative. It’s a partnership. And it’s been a wonderful experience for us in Salt Lake to work hand-inhand with the IOC, and particularly President Bach, to direct us [to] the right place so that we ended up with the right solution.  It’s important that the [Refugee Olympic Team] was created, mainly for many refugees all around the world, athletes and non-athletes. A lot of refugees go through so many obstacles and don't get the opportunity or the support that they need. And [thanks] to the IOC, we are able to be given the light and be given a team, a family. What makes us special and unique compared to any other athlete around the world is that we all have different backgrounds, but the main thing that brings us together is that we are refugees. I’m over the moon that I was able to get myself a medal and be the ﬁrst-ever member of the IOC Refugee Olympic Team to win a medal and show all the humans and all the refugees around the world that we are just like any other athlete and we aim high."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 28-icon\" style=\"top:69px;left:450px;\" src=\"/124/static/_content/28-icon-1.png\"/>\n        <img class=\"abs halfScale 28-caption\" style=\"top:218px;left:495px;\" src=\"/124/static/_content/28-caption-1.png\"/>\n        <img class=\"abs halfScaleC 28-icon\" style=\"top:538px;left:40px;\" src=\"/124/static/_content/28-icon-2.png\"/>\n        <img class=\"abs halfScale 28-caption\" style=\"top:570px;left:127px;\" src=\"/124/static/_content/28-caption-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          page28Anim = new TimelineMax();\n          page28Anim.staggerFromTo(cOf(\"28-icon\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  0.1, 1)\n          .staggerFromTo(cOf(\"28-caption\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.1, 1.1)\n        }\n\n        function onPageLeave() {\n          page28Anim.stop();\n        }\n      ",
    "searchText": "28  Feature: Testimonials  Sam Ramsamy  IOC Honorary Member  Alaa Maso  IOC Refugee Olympic Team member Through the IOC programme supporting the displaced athletes, I was able to live my dreams. I was able to compete [on] very big stages. I never really knew I [was] going to be doing it – [I] maybe imagined, maybe visualised myself doing it, but never really had the chance to have it. I will forever be thankful for the Olympic Movement and the way they were able to support us. I think somehow sport does bring people together. And that's the Olympic spirit. That's what it's all about.  The Olympic Movement now has on its agenda – fair play. It has on its agenda – equality. It has on its agenda – all other aspects that Olympism stands for. [President Bach] has harnessed that. I have to say that I am very, very happy with the way he has conducted the Olympic Movement. He has made sure that the International Federations are intact, he made sure that the NOCs are intact, and obviously the membership is intact. And that in the end is a three-component part because we cannot only concentrate on the IOC Members, although the IOC Members are the ones who elected him. Getting sports like sport climbing [and] skateboarding has helped immensely. In fact, we have already noticed that the inspiration that has been provided has in fact gone to such an extent and expanded to such an extent that we will see wider participation in the Olympic Movement. I think generally that is what Olympic Agenda stands for. Wider participation, a participation on an inclusive basis and not on an exclusive basis. In fact, Thomas always said: ‘What I think is important for the Olympic Movement is to create unity in diversity.’ And he has created that to a large extent."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Bold innovations for  peak performance Through our technology integration services we’re helping the IOC keep innovation, impact, and legacy at its heart."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 30-icon-1\" style=\"top:92px;left:37px;\" src=\"/124/static/_content/30-icon-1.png\"/>\n        <img class=\"abs halfScale 30-caption-1\" style=\"top:125px;left:123px;\" src=\"/124/static/_content/30-caption-1.png\"/>\n        <img class=\"abs halfScaleC 30-icon-2\" style=\"top:603px;left:378px;\" src=\"/124/static/_content/30-icon-2.png\"/>\n        <img class=\"abs halfScale 30-caption-2\" style=\"top:641px;left:464px;\" src=\"/124/static/_content/30-caption-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          page30Anim = new TimelineMax();\n          page30Anim.fromTo(cOf(\"30-icon-1\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  1)\n          .fromTo(cOf(\"30-caption-1\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.1)\n          .fromTo(cOf(\"30-icon-2\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  1.1)\n          .fromTo(cOf(\"30-caption-2\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n        }\n\n        function onPageLeave() {\n          page30Anim.stop();\n        }\n      ",
    "searchText": "Jessica Fox  IOC Member; three-time Olympic gold medallist  President Bach, 11 years ago, I had the honour of being one of 10 Olympians to come to Lausanne and participate with you in the consultation process for Olympic Agenda 2020. You valued our voices and our diverse experiences. You opened the door to new perspectives to help you shape the future. It was a deﬁning moment that inspired me to take on roles representing  athletes in my sport and in my country. And as a competitive athlete in Rio, Tokyo and Paris, I felt ﬁrst-hand the transformative impact of the Olympic Agenda 2020 reforms. Paris, in particular, was remarkable. I felt that these Games were clearly successful and progressive. But more than that, you could feel the Olympic  spirit ﬂourishing. You could feel that we were bringing the whole world together. And it was more egalitarian, more inclusive, more sustainable, more athlete-centred, with an incredible atmosphere, venues and stories that celebrated the Olympic values. Under your leadership, President Bach, the reforms you have carried out have strengthened our role within the Movement.  Luis Alberto Moreno IOC Member  I would like to draw the attention of all my colleagues to another dimension: your diplomatic skills that I have had the privilege of seeing with my own eyes. Having spent a good part of my life in multilateral institutions, it is not easy to reach a consensus on ideas. I saw how you were able to listen. At the end of the day, diplomacy is about building bridges where there are none. It reminds me of the famous quote attributed to Gandhi: ‘First they ignore you, then they laugh at you, then they ﬁght you and ﬁnally you win.’ Mr President, you have won for all of us. Thank you very much."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 31-icon\" style=\"top:607px;left:47px;\" src=\"/124/static/_content/31-icon-1.png\"/>\n        <img class=\"abs halfScale 31-caption\" style=\"top:643px;left:133px;\" src=\"/124/static/_content/31-caption-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          page31Anim = new TimelineMax();\n          page31Anim.fromTo(cOf(\"31-icon\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.2)\n          .fromTo(cOf(\"31-caption\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n        }\n\n        function onPageLeave() {\n          page31Anim.stop();\n        }\n      ",
    "searchText": "31  Anita DeFrantz  IOC Member; Olympic bronze medallist I am delighted with everything that has been said and all the applause. It has been very well understood what you have done and, of course, also for women. Thank you for having accomplished our mission of increasing the number of women in the IOC and in sport. I wanted to add something that not everyone knows about you: your kindness. You are always there for someone who has been injured or has  problems, and you do it calmly and immediately. Your calls of support made a big difference to me and allowed me to be sure that I could be here at this IOC Session. I am deeply grateful to you. I know of many other acts of kindness that you have performed. You are both extraordinarily tough and extraordinarily kind and that is why I really appreciate your legacy. I had the privilege of voting  for your membership of the IOC and then I saw how you went from a backbencher to the front of the room. I congratulate you. It wasn’t easy, but you did it. Mr President, I thank you for everything that others have said speciﬁcally for women, but above all for your kindness as a leader, which is extremely important and does not always happen, so thank you for being a leader and a friend."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 32-icon\" style=\"top:89px;left:61px;\" src=\"/124/static/_content/32-icon-1.png\"/>\n        <img class=\"abs halfScale 32-caption\" style=\"top:121px;left:148px;\" src=\"/124/static/_content/32-caption-1.png\"/>\n        <img class=\"abs halfScaleC 32-icon\" style=\"top:198px;left:415px;\" src=\"/124/static/_content/32-icon-2.png\"/>\n        <img class=\"abs halfScale 32-caption\" style=\"top:339px;left:459px;\" src=\"/124/static/_content/32-caption-2.png\"/>\n        <img class=\"abs halfScaleC 32-icon\" style=\"top:498px;left:415px;\" src=\"/124/static/_content/32-icon-3.png\"/>\n        <img class=\"abs halfScale 32-caption\" style=\"top:639px;left:462px;\" src=\"/124/static/_content/32-caption-3.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          page32Anim = new TimelineMax();\n          page32Anim.staggerFromTo(cOf(\"32-icon\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)},  0.1, 1)\n          .staggerFromTo(cOf(\"32-caption\"), 1, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.1, 1.1)\n        }\n\n        function onPageLeave() {\n          page32Anim.stop();\n        }\n      ",
    "searchText": "32  Feature: Testimonials  Allyson Felix  IOC Member; seven-time Olympic gold medallist You encouraged me to get involved in the Athletes’ Commission. I was very hesitant. Thanks to your encouragement, I decided to get involved and since then it has been a very eye-opening experience and, on behalf of the Athletes’ Commission, we just want to thank you for always being attentive to the services to athletes. Thank you for always putting athletes at the centre of your concerns, and I know we are all inspired by that and will continue to work to make sure that continues.  Anant Singh IOC Member  We have talked a lot about leadership over the years, and I have had the honour of being led by you. The leadership for which we both have great admiration is that of Nelson Mandela. You have adopted many of the ideals and objectives found in the way he led, and I have observed this during my seven years here. It has been a great source of inspiration to have been led by you.  Samira Asghari IOC Member  While all efforts have been made to stick to the original transcripts, some interviews have been slightly edited to improve ﬂow.  In terms of gender equality, human rights and, in particular, women’s rights, you are our champion. I come from Afghanistan. When everyone forgot about Afghanistan, when all the world leaders forgot about Afghanistan, the only place we looked to was the Olympic Games. And under your leadership, we saw our women everywhere, and your arms were always open. The Afghan people are grateful to the Olympic Movement, especially for your support."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Not for minors."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 34-quote\" style=\"top:29px;left:36px;\" src=\"/124/static/_content/34-quote-1.png\"/>\n        <img class=\"abs halfScale 34-quote\" style=\"top:121px;left:36px;\" src=\"/124/static/_content/34-quote-2.png\"/>\n        <img class=\"abs halfScale 34-quote\" style=\"top:229px;left:36px;\" src=\"/124/static/_content/34-quote-3.png\"/>\n        <img class=\"abs halfScale 34-quote\" style=\"top:335px;left:36px;\" src=\"/124/static/_content/34-quote-4.png\"/>\n        <img class=\"abs halfScale 34-quote\" style=\"top:442px;left:36px;\" src=\"/124/static/_content/34-quote-5.png\"/>\n        <img class=\"abs halfScale 34-quote\" style=\"top:549px;left:34px;\" src=\"/124/static/_content/34-quote-6.png\"/>\n        <img class=\"abs halfScale 34-quote\" style=\"top:655px;left:36px;\" src=\"/124/static/_content/34-quote-7.png\"/>\n        <img class=\"abs halfScale 34-quote\" style=\"top:762px;left:36px;\" src=\"/124/static/_content/34-quote-8.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          page34Anim = new TimelineMax();\n          page34Anim.staggerFromTo(cOf(\"34-quote\"), 0.8, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.1, 1)\n        }\n\n        function onPageLeave() {\n          page34Anim.stop();\n        }\n      ",
    "searchText": "“"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink abs\" style=\"top:461px; left:415px; width:108px; height:13px;\">\n          <a href=\"https://www.olympics.com/ioc/144th-ioc-session\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink abs\" style=\"top:461px; left:527px; width:110px; height:13px;\">\n          <a href=\"https://newsroom.olympics.com/record/1651\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink abs\" style=\"top:478px; left:254px; width:86px; height:13px;\">\n          <a href=\"https://newsroom.olympics.com/record/1651\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n        setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "1  2  IN A HISTORIC VOTE AT THE 144TH IOC SESSION, KIRSTY COVENTRY WAS ELECTED THE 10TH PRESIDENT OF THE IOC, COMPLETING A REMARKABLE JOURNEY FROM WHEN SHE FIRST BECAME INSPIRED BY THE OLYMPIC GAMES AS A CHILD IN ZIMBABWE. BY STEVE WILSON  K 1 Kirsty Coventry will become the ﬁrst female President of the IOC. 2 Seven medals in the pool made her Africa’s most decorated Olympian.  irsty Coventry was nine years old when she ﬁrst glimpsed the global sporting event that would change her life and secure her place in history. At home in Harare, Zimbabwe, the young girl was captivated by the television footage of the Olympic Games in Barcelona in 1992. Images of the picturesque swimming venue and stunning backdrops of the Spanish city inspired Coventry on a journey to a glittering Olympic swimming career and, eventually, the top leadership role in world sport. “Something about Barcelona just caught my eye,” she recalled. “I said to my parents, ‘I want to go to the Olympic Games one day and win Zimbabwe a gold medal.’ They just smiled and said, ‘OK, well it’s going to take a lot of hard work and sacriﬁce’.”  As it turned out, Coventry went on to compete in ﬁve Olympic Games, winning seven medals, including two gold, making her Africa’s most decorated Olympian. But it was out of the pool where she made the biggest splash of all. On 20 March 2025, Coventry was elected the 10th President of the International Olympic Committee at the 144th IOC Session in Costa Navarino, Greece. At the age of 41, she became the ﬁrst woman and ﬁrst African chosen to lead the 131-year-old organisation. “This is an extraordinary moment,” Coventry said after the result was announced by outgoing IOC President Thomas Bach. “As a nine-year-old girl I never thought that I would be standing up here one day, getting to give back to this incredible movement of ours.” Since its founding in 1894, the IOC had been headed by nine men – eight Europeans"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 36-quote\" style=\"top:558px;left:469px;\" src=\"/124/static/_content/36-quote-1.png\"/>\n        <div class=\"addContentLink abs\" style=\"top:-1px; left:256px; width:409px; height:526px;\">\n          <a href=\"https://www.olympics.com/en/athletes/kirsty-leigh-coventry\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          page36Anim = new TimelineMax();\n          page36Anim.fromTo(cOf(\"36-quote\"), 0.6, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          page36Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "36  Feature: Kirsty Coventry  and one American. Coventry, only the second woman ever to run for the post, prevailed over six other candidates in the ﬁrst round with 49 out of 97 votes. “It is a really powerful signal we are truly global and evolved into an organisation open to diversity,' she said. Born on 16 September 1983 in Harare, Coventry learned to swim at age two, taught by her mother and grandfather. She joined her ﬁrst swimming club at six and quickly developed a competitive streak. Without indoor pools, she played other sports in winter, including hockey, cross-country and tennis, but swimming remained her passion. “Swimming was my safe haven,” she said. “I did ﬁne at school but was never an A student. In the pool, I was able to ﬁnd who I was.” A hockey injury at 14 convinced Coventry to focus solely on swimming. As a 16-year-old high schooler, she qualiﬁed for the Olympic Games in Sydney in 2000. “It was a little bit daunting coming all the way from Zimbabwe and walking onto that pool deck,” she said. Though she didn’t win a medal in Sydney, Coventry became the ﬁrst Zimbabwean swimmer to reach an Olympic semi-ﬁnal. Her fondest memory, though, wasn’t in the pool but in the Olympic Village, where she met Muhammad Ali as he was being mobbed by star-struck athletes. “That moment lit something inside me,” she said. Coventry’s big breakthrough came four years later in Athens, where she won three medals, including Zimbabwe’s ﬁrst individual Olympic gold in the 200m backstroke. “Standing on the podium was quite surreal,” she said. “I was thinking back to when I was nine years old. I was now nearly 21 and realised I had ﬁnally achieved my goal and my dream.” Returning to Zimbabwe, she was met with a rapturous hero's welcome, a powerful symbol at a time when the country was torn by internal strife. “I didn’t quite know what to expect when I went home,’’ Coventry said. “But I remember landing and the airplane had to stop short of the gate because there were so many people that had come out to meet me. “Zimbabweans came out to thank me and say, ‘We’re so proud.’ It showed me how powerful sport can be to break down barriers and bring people together.”  1  It was a memory that shaped Coventry’s IOC presidential campaign, a message she shared in her presentation to IOC Members in January. “The transformative power of sport – that’s not just something I’ve said, but I’ve actually lived it and seen it. And I believe in it,” she said. “At a time when our world is so divided, the Olympic Movement can help bridge gaps, build back trust and showcase the best of humanity.” Coventry picked up four more medals at Beijing 2008, including another gold in the 200m backstroke and three silvers. She competed at London 2012 and Rio 2016 before retiring with seven career Olympic medals, the most by an African athlete. A key factor in Coventry’s success was an Olympic Solidarity scholarship. She left Harare at age 17 to attend Auburn University in Alabama, USA, where she led the “Tigers”  “The transformative power of sport – that’s not just something I’ve said, but I’ve actually lived it and seen it” IOC PRESIDENT-ELECT KIRSTY COVENTRY  swim team to three NCAA championships in 2002, 2003 and 2004. She graduated from Auburn in 2006 with a degree in hotel and restaurant management. “Going to Auburn played a huge role in my life in giving me a platform,” Coventry said. “My team-mates are friends and family for life.” Coventry joined the IOC in 2013 as an athlete Member. She chaired the Athletes’ Commission and served on the Executive"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  37  Issue 124  4  3 2  Board from 2018 to 2021. She was elected an Individual Member in 2021 and re-elected to the Executive Board in 2023. Meanwhile, she dedicated herself to giving back to her community in Zimbabwe. She founded the Kirsty Coventry Academy to teach children how to swim and, alongside her husband, Tyrone Seward, created the HEROES programme to provide a safe sports environment for kids aged six to 13. In 2018, Coventry was appointed Zimbabwe’s Minister of Youth, Sport, Arts and Recreation, where she worked on legislation to combat match-ﬁxing, abuse and sexual harassment in sports. “I enjoy challenges,” Coventry said. “I trust my gut. My gut has always led me down the right path. I really do enjoy challenging myself. I enjoy trying to step out of my comfort zone and do something new, knowing sometimes you’re bound to fail.  3  It’s about picking yourself up and trying again, or just moving forward and learning from it.” Coventry has also learned from others, citing her strong-willed grandmothers as powerful role models. After winning the IOC election, she paid special tribute to longtime US IOC Member and women’s advocate Anita DeFrantz, calling her “a huge inspiration”. “I was very proud I could make her proud,” an emotional Coventry said. “She was the ﬁrst woman to run for this position. Women like her paved the way for women like me.” All the while, she embraced family life. She and Seward married in 2010 and welcomed their ﬁrst daughter in 2019. Their second daughter was born in 2024 during Coventry’s IOC presidential campaign. “My youngest has ﬁt right in,” Coventry said. “She has travelled with me since she was four weeks old. Being with my husband and daughters is where I ﬁnd my down time.”  Fittingly, Coventry’s family was present in Greece for her election as IOC President. Among the ﬁrst to congratulate her was her ﬁve-year-old daughter. “My little girl ran up and said, ‘Mum, you won!’” Balancing motherhood with the IOC presidency is a challenge that Coventry welcomes. “I want my daughters to grow up knowing that they can be whatever they want to be and do whatever they want to achieve,” she said. Just like their mother. ■  1 Kirsty Coventry was a ﬂagbearer for Zimbabwe at the Opening Ceremony of the Olympic Games Rio 2016. 2 Speaking at the International Athletes’ Forum in her role as IOC Athletes’ Commission Chair. 3 Joining fellow Olympians for the ﬁnal leg of the Paris 2024 Olympic Torch Relay. 4 With IOC President Thomas Bach at the 144th IOC Session."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 38-title\" style=\"top:275px;left:81px;\" src=\"/124/static/_content/38-title-1.png\"/>\n        <img class=\"abs halfScale 38-title\" style=\"top:425px;left:80px;\" src=\"/124/static/_content/38-title-2.png\"/>\n        <img class=\"abs halfScale 38-caption\" style=\"top:582px;left:142px;\" src=\"/124/static/_content/38-caption-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          page38Anim = new TimelineMax();\n          page38Anim.staggerFromTo(cOf(\"38-title\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"38-caption\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)\n        }\n\n        function onPageLeave() {\n          page38Anim.stop();\n        }\n      ",
    "searchText": "THROUGH THE LENS SINCE BECOMING IOC PRESIDENT IN 2013, THOMAS BACH HAS DRIVEN REFORM AT THE IOC, WITH OLYMPIC AGENDA RESHAPING SUSTAINABILITY, GENDER EQUALITY AND YOUTH ENGAGEMENT IN THE GAMES"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "01.  Olympic Agenda has put athletes at the heart of the Olympic Movement. Here, President Bach joins athletes at the Closing Ceremony of Paris 2024 as the Olympic ﬂame is extinguished."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "01  01.  Thomas Bach was the ﬁrst Olympic champion to hold the presidency of the IOC. He won team fencing gold at the Olympic Games Montreal 1976.  02.  Bach (right) and his West Germany team-mates won the team foil competition, beating Italy in the ﬁnal.  02"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "03"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "01  02  01.  At its inauguration in May 2019, Olympic House was one of the most sustainable buildings in the world and received LEED Platinum Certiﬁcation for its construction. In May 2024, it was awarded the LEED Platinum for Operations and Maintenance (O+M) certiﬁcation, which recognises the high sustainability performance of the building’s operations and the IOC’s commitment to sustainability.  02.  The historic decision in 2017 to award the 2024 and 2028 Olympic Games to Paris and Los Angeles was the culmination of a two-year process shaped by Olympic Agenda reforms, encouraging more coherent planning and development of the Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Ready? Check! Summer or Winter, athletes are always looking for those marginal gains. And with the Allianz Safety Sled, we’re giving bobsleigh pilots that UHDVVXULQJļQDOFRXUVHFKHFN EHIRUHWKHUDFHEHJLQV $KHDGRIWKH2O\PSLF:LQWHU Games Milano Cortina 2026, we’re proud to partner with athletes to improve safety standards in sports.  ,PDJH%6'9LHVWXUV/DFLV"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "01.  The joint march between the Republic of Korea and the Democratic People's Republic of Korea at the Opening Ceremony of PyeongChang 2018 showed the unifying effect of sport.  02.  Paris 2024 became the ﬁrst Olympic Games to achieve full gender parity on the ﬁeld of play, with several exciting mixed team events such as judo.  01"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n      <a href=\"https://www.youtube.com/watch?v=ga37uov5DHQ\" target=\"_blank\"><img class=\"halfScaleC halfpulse animatedpulse pointer z-index-set\" src=\"/124/static/_content/play-btn.png\" style=\"top:79px;left:543px;\" /></a>\n      ",
    "script": "\n        function onPageEnter() {\n        setTimeout(function(){\n          addContentLinks();\n        },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "02"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "01"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "02  03  01.  After serving as Chair of the IOC Athletes’ Commission, Kirsty Coventry was elected the 10th President of the IOC at the 144th IOC Session in Costa Navarino, Greece. She is the second Olympic champion to be elected President.  02.  Thirty-seven athletes competed at Paris 2024 for the IOC Refugee Olympic Team, which has ﬂourished since making its debut at Rio 2016.  03.  Salt Lake City-Utah 2034, host of the XXVII Olympic Winter Games, is fully aligned with Olympic Agenda and will build on the legacy of the 2002 Winter Games, while also focusing on building long-term beneﬁts for the region."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 50-title\" style=\"top:170px;left:120px;\" src=\"/124/static/_content/50-title-1.png\"/>\n        <img class=\"abs halfScale 50-title\" style=\"top:295px;left:159px;\" src=\"/124/static/_content/50-title-2.png\"/>\n        <img class=\"abs halfScale 50-title\" style=\"top:420px;left:65px;\" src=\"/124/static/_content/50-title-3.png\"/>\n        <img class=\"abs halfScale 50-caption\" style=\"top:693px;left:93px;\" src=\"/124/static/_content/50-caption-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg50Anim = new TimelineMax();\n          pg50Anim.staggerFromTo(cOf(\"50-title\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"50-caption\"), 0.6, {opacity:0, y:50}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.6)\n        }\n\n        function onPageLeave() {\n         pg50Anim.stop();\n        }\n      ",
    "searchText": "ATHLETES AT THE  HEART AFTER THE OLYMPIC AGENDA REFORMS PLEDGED TO PUT ATHLETES FRONT AND CENTRE, GUY GILES EXPLORES HOW THE PAST DECADE HAS EMPOWERED ATHLETES ACROSS THE OLYMPIC MOVEMENT"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "The Champions Park at Paris 2024 put the spotlight on the medallists."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 52-title\" style=\"top:107px;left:65px;\" src=\"/124/static/_content/52-title-1.png\"/>\n\n        <div class=\"addContentLink\" style=\"top:552px;left:149px;width:59px;height:13px\">\n          <a href=\"https://www.olympics.com/ioc/athletes-commission\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:566px;left:42px;width:56px;height:13px\">\n          <a href=\"https://www.olympics.com/ioc/athletes-commission\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg52Anim = new TimelineMax();\n          pg52Anim.fromTo(cOf(\"52-title\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg52Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "52  Feature: Athletes at the heart  Strengthening athletes’ rights and responsibilities  Let’s start with a quick history lesson... 1  I  n September 1981, at the XI Olympic Congress in Baden-Baden, Germany, the athlete voice was heard for the ﬁrst time in the Olympic Movement. With 25 Olympians in attendance, six were chosen to deliver speeches on topics important to athletes. Among those speaking to the 469 official delegates was a certain Olympic gold medallist in fencing called Thomas Bach. Although their speeches were short, they were powerful enough to change the Olympic Movement forever. Just one month later, the IOC Athletes’ Commission (AC) was formed by then-IOC President Juan Antonio Samaranch, with all six athlete speakers appointed among its nine founding members. A ﬁrst meeting followed in May 1982, with the commission becoming an active voice on topics such as anti-doping, gender equality and eligibility rules. Over the next 14 years, membership grew from nine to 14. In 1996, the commission expanded again to 19 members but, more importantly, 10 of these were now chosen by fellow athletes through elections at the Olympic Games. Possibly the most signiﬁcant sea change for the athlete voice came in 2000, when athletes entered the IOC membership for the ﬁrst time, an  arrangement that remains in place today. Of the 15 athlete Members, 12 are elected IOC AC members, with the chair also becoming a member of the IOC Executive Board (EB). From those six speeches 19 years prior, athletes were now much more than their sporting excellence on the ﬁeld of play – they had taken their place as an integral part of the decision-making processes within the IOC, with a say in the future of the Olympic Movement.  The role of athletes continued to grow throughout the first decade of the 21st century, but it was December 2014 which saw the next leap forward for athletes: the launch of Olympic Agenda 2020. Of the 40 recommendations, five were built specifically to promote the athletes’ place at the heart of the Olympic Movement. These included legal changes to the Olympic Charter, more protection for clean athletes, developing the athlete experience at the Olympic Games and strengthening athlete support – both on and off the field of play. In 2021, this mission was continued by its successor, Olympic Agenda 2020+5, which further pledged to strengthen athletes’ rights and responsibilities. Together, these roadmaps have acted as an important catalyst for the consolidation and advancement of the role of athletes at the centre of the Olympic Movement. “As an Olympian, the commitment to placing athletes at the heart of the Olympic Movement is profoundly meaningful,” says Jeremy Dodson, who represented Samoa in athletics at the Olympic Games Rio 2016 and now works in the IOC Athletes’ Department. “It signifies a shift towards prioritising the needs, voices and well-being  2"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  53  Issue 124  of athletes in every decision, ensuring that athletes are not just participants but integral stakeholders in shaping the future of the Olympic Games and the global sporting community.”  Athletes driving decisions The journey that started in 1981, with those six historic speeches and the establishment of the IOC AC, has taken athletes from the heart of the sporting action to the centre of the decision-making processes within the IOC. Not only does the IOC membership include up to 15 athletes – a number on par with presidents of National Olympic Committees (NOCs) and International Federations (IFs) – but athletes are also present on every relevant IOC commission, in addition to the IOC EB. “When there is a topic that might affect athletes, our members are part of these discussions and aware of what’s happening,” explains IOC AC Chair Emma Terho, a five-time Olympian who won two bronze medals as part of Finland’s women’s ice hockey team. “This means the athletes’ voice is heard at the very beginning of the decision-making process. “When these initiatives move forward, I bring the athlete perspective to any discussions in the Executive Board. And then, of course, at the IOC Session, we have 15 members making sure the athletes’ voice is heard in front of a bigger audience.” As part of its leading role for athletes within the Olympic Movement, the IOC AC is at the heart of the global network of athlete representatives, made up of ACs across NOCs and IFs. This network has grown substantially in recent years, with more than 190 of 206 NOCs having now established their own AC. “Everything starts with providing the best possible experience for athletes – that is the core from which we build everything else,” says Terho. “It’s super important for us to work with the global network because the challenges athletes face are different depending on where they are from. “That means spreading out to the local level, making sure that we give athletes a say, not only in their everyday work but in how the Olympic Movement is shaped, first in their local context and then obviously at the Olympic Games.”  3  Keeping athletes connected to the IOC and the Olympic Movement is key in creating a strong athlete network. Whether it’s the IOC President engaging with athletes at the International Athletes’ Forum or the Olympic Games, or IOC AC members bringing their expertise to the local level, it’s these interactions that foster a more powerful athlete voice. “It's a game-changer getting to interact with them, share our experiences, and for them to share their experiences with us,” explains Kenya NOC AC member Wilkistar Nyiro, who engaged with Terho and IOC AC member Humphrey Kayange, an Olympian in rugby sevens, at the most recent ANOCA (Association of African NOCs) Athletes’ Forum. “This is a good move by the IOC because now we are relating to our leaders and they're also able to hear from us directly.” 1 The XI Olympic Congress in Baden-Baden, Germany, marked a key moment for athlete representation. 2 Thomas Bach was a founding member of the IOC AC, formed under President Samaranch (left). 3 IOC AC President Emma Terho (right) helps athletes settle in at the Athlete365 House at Paris 2024.  A first-of-its-kind athletes’ department The growth and increased synergy of the global athlete network has been further galvanised by one of the key outcomes of Olympic Agenda 2020+5 – the creation of an Athletes’ Department within the IOC. Established in May 2021, the department is led by Kaveh Mehrabi, Olympian in badminton, with a further eight Olympians and a former elite-level athlete among its 22 staff members. Dedicated specifically to working for athletes, the department consists of four units: support and partnerships, athlete and Olympian relations, community engagement, and communications and digital activation. “The IOC Athletes’ Department is a group of individuals passionate about supporting the sporting community, personally and professionally,” says Dodson, who brings his experience as an Olympian to the role of Athlete & Olympian Relations Project Manager. “The department is a unique collection of athletic viewpoints, working closely with the IOC AC to ensure that the athletes’ perspective is represented in IOC decisions.”"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top:649px;left:81px;width:53px;height:13px\">\n          <a href=\"https://www.olympics.com/athlete365\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "54  Feature: Athletes at the heart  Close contact with the IOC AC and the global athlete network is crucial to the department’s aims of increasing athlete engagement, strengthening ACs and providing a wealth of support initiatives to athletes around the world. “We create programmes and resources that help athletes in all phases of their careers, from development ages onto the transition out of sporting careers,” Dodson explains. “Although the Olympic Games are the highlight of an athletic career, we work all year round to ensure the athletes are successful in every area of their life.” Rodrigo Garza, Olympic silver medallist for Spain in men’s hockey at Beijing 2008 and member of the athlete partnerships team, highlights the benefits of having Olympians, who have lived the athlete journey from the first steps in their sport to retirement, at the forefront of the department’s work. “We know what it feels like to face uncertainty after competing,” he says. “It builds trust, too. Athletes feel more comfortable knowing that the support they’re getting comes from someone who’s walked the same path.”  1  By athletes, for athletes The presence of athletes at the heart of the IOC administration and the growth of the global network of athlete representatives are key legacies of the past decade, but how have the lives of athletes actually changed? Under Olympic Agenda 2020 Recommendation 18, which aimed to strengthen support to athletes, came one key goal: “Offer a one-stop-shop for athletes to access all relevant content on important topics related to their career on and off the field of play.” Enter Athlete365. Since launching in 2017, Athlete365 has become the world’s largest community of athletes, with more than 200,000 members, including Olympians, Paralympians, elite athletes and entourage members. Driven by the simple mission of making athletes’ lives better, the platform provides exclusive offers, expert advice and tailored content to support athletes at every stage of their journey – delivered in six languages. As well as a website, app and social channels accessible to all athletes across different regions, Athlete365 also offers  physical spaces for learning and engagement at the Olympic Games and other events. So, what do the athletes say? “Athlete365 has been very useful during my Olympic journey,” states Alpine skier Márton Kékesi, two-time Olympian for Hungary. “It deepened my understanding of the Olympic Movement and made the Games more engaging by offering team-building programmes at the Athlete365 House during our rest days. I appreciate being part of a community that supports athletes between Games, offering growth opportunities.” Ghailene Khattali competed for Tunisia in canoe sprint at Tokyo 2020 and Paris 2024 and says the platform has been an asset as he pursues a dual career: “Athlete365 represents a window for me to find all the programmes that can help me as an athlete or as an entrepreneur.” One of the key pillars of the Athlete365 offering is its learning platform, with courses designed to help athletes and their entourages gain new skills and knowledge across a wide array of topics. Athlete365 Learning also collaborates with Worldwide  Olympic Partners (TOPs) such as Alibaba, Airbnb, Allianz, Coca Cola, Deloitte, P&G, Samsung and Visa to bring their expertise to athletes. In 2024, nearly 17,000 athletes took more than 25,000 courses on Athlete365 Learning, a respective 46 per cent and 31 per cent rise on the previous year. “We have expanded our resources beyond career support to include mental health, safeguarding and personal brand development, continuously adapting to athletes’ evolving needs,” explains Maria Ntanou, Athlete & Olympian Communications Manager – and three-time Winter Olympian herself. As a free tool available to all who sign up, Athlete365 Learning is accessible to any athlete – wherever they are in their career. Romio Recardo Goliath, vice-chair of the Namibia AC and LA28 hopeful, says: “Athlete365 Learning has been a valuable resource in my wrestling journey,  1 The Athlete365 House provided a place for athletes to mix with one another and to learn about athlete-focused programmes to beneﬁt their careers."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 55-quote\" style=\"top:399px;left:69px;\" src=\"/124/static/_content/55-quote-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg55Anim = new TimelineMax();\n          pg55Anim.fromTo(cOf(\"55-quote\"), 0.6, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg55Anim.stop();\n        }\n      ",
    "searchText": "55  “[Access to grants through Athlete365] was essential for my Olympic qualification” GIULLIA PENALBER, WRESTLING, BRAZIL  providing me with useful information, tips and guidance to improve my performance and well-being.”  Giving athletes a helping hand For athletes who sign up to Athlete365, there is also a range of tangible support available – including the Airbnb Athlete Travel Grant and Airbnb500, which have reached thousands of athletes since their launch in 2020. The road to the Olympic Games can be a long one, with training camps and competitions across the globe sometimes placing financial strain on athletes. To ease  this pressure, the Airbnb Athlete Travel Grant provides successful applicants with up to USD 2,000 to spend on Airbnb accommodation during competition or training trips. As of December 2024, a total of 3,000 grants had distributed USD 4 million of financial support to Olympic and Paralympic hopefuls – sometimes making all the difference in their quest for the Games. “It was essential for my Olympic qualification, especially mentally speaking,” explains wrestler Giullia Penalber, who represented Brazil at Paris 2024. “I was able to pay for accommodation for my coach and some team members to accompany me  on training camps that I didn't previously have the support for. It gave me more peace of mind by allowing me to train and have moments of rest with the people I needed on the journey.” Those moments of rest are essential, particularly after the Games, which represent the culmination of a lifetime of hard work and sacrifice. This is where the Airbnb500 comes in. Available to all Olympians and Paralympians competing at every Games since Tokyo 2020, the Airbnb500 gives athletes USD 500 in Airbnb credits to unwind afterwards or pursue their next sporting goal. More than 13,000"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "56  Feature: Athletes at the heart  Olympians and 5,000 Paralympians have taken up the offer to date, amounting to more than USD 9 million in financial support. “After Paris 2024, my fiancé and I travelled to Italy for a much-needed rest and recharge,” says Canadian artistic swimmer Jacqueline Simoneau. “This gave us the perfect opportunity to unwind and reflect on the whirlwind of competing at my third Games. It was a beautiful way to reset physically and mentally, helping me return to school with fresh energy and focus.”  Navigating the transition Direct support for athletes doesn’t stop there. Since its inception, a key priority for Athlete365 has been guiding athletes through possibly the toughest part of their careers: the transition away from sport. After years of working towards a big goal – often the Olympic or Paralympic Games – the end of an athletic career can be a challenging time. The Athlete365 Career+ programme, initially set up in 2005, has supported more than 60,000 athletes through this transition, with expert advice, skills building, and employment and networking opportunities.  1  2  This multi-faceted approach is spearheaded by workshops, conducted in collaboration with NOCs and IFs, with athletes learning how their existing skills can transfer to the working world, developing selfunderstanding and assessing their options after retirement. More than 15,000 athletes across five continents have attended an Athlete365 Career+ workshop to date, and in 2024 workshops were delivered in eight languages. The workshops are led by IOC-trained educators like Maria Barakat of the Jordan Olympic Committee. “It’s incredibly rewarding to watch athletes not only learn but challenge their thinking,” she says. “The process of self-exploration builds their confidence, connects their strengths in sport with career opportunities and makes them realise that their potential extends far beyond the field of play.”  1 Athlete365 collaborates with NOCs and IFs to bring specialised workshops to athletes around the world. 2 Former athletes were given an exclusive opportunity to join the OBS team at Paris 2024."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 57-quote\" style=\"top:624px;left:68px;\" src=\"/124/static/_content/57-quote-1.png\"/>\n\n        <div class=\"addContentLink\" style=\"top:169px;left:382px;width:61px;height:13px\">\n          <a href=\"https://www.olympics.com/ioc/partners\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg57Anim = new TimelineMax();\n          pg57Anim.fromTo(cOf(\"57-quote\"), 0.6, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg57Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "57  For athletes seeking more individualised career support, the Athlete365 Mentoring programme offers one-on-one sessions with experts from across the Olympic Movement, including senior figures working for the global brands that make up the IOC’s TOP Partners, and the IOC itself. Now in its third cohort, the programme has given more than 200 athletes the chance to benefit from the expertise of a mentor as well as networking opportunities. “When you’re thinking, ‘What am I going to do after I retire?’, it can be really scary,” explains Brazilian archer Bernardo Oliveira. “To be able to meet other athletes going through the same thing and get practical advice on what to do and how to prepare – it was really a great opportunity.”  Opportunities for growth Having this support is crucial, but athletes also need to be able to put their new skills and knowledge into action. Under the Olympic Agenda reforms, a concerted effort has been made to increase athlete employment opportunities, including positions within the IOC, at the Olympic Games and through TOP Partner programmes.  “[Airbnb500] gave us the perfect opportunity to unwind and ref lect on… the Games” JACQUELINE SIMONEAU, ARTISTIC SWIMMING, CANADA  At Paris 2024, 41 Olympians and six Paralympians were employed by Olympic Broadcasting Services (OBS) thanks to the Olympic Commentary Training and the Broadcast Training Programme. Providing world-class training across a number of roles, these OBS initiatives turn athletes into professional broadcasters and offer successful participants the chance to sign Games-time contracts. Mark Hawkins, who represented Great Britain in handball at London 2012 and commentated for OBS in Paris, appreciated the opportunity to contribute to the Games in a new way – and the boost to his career. “It's amazing to be involved in the Olympics at any level. It's a massive potential springboard,” he says. Athletes with a mind for business have a springboard of their own in the Athlete365 Business Accelerator programme. Designed to help athletes launch their own businesses, the initiative matches them with local mentors and industry experts to guide them through the process. In 2024, Alibaba became a supporter of the programme, bringing its e-commerce expertise to athletes and their businesses."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 58-quote\" style=\"top:445px;left:393px;\" src=\"/124/static/_content/58-quote-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg58Anim = new TimelineMax();\n          pg58Anim.fromTo(cOf(\"58-quote\"), 0.6, {opacity:0, y:10}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg58Anim.stop();\n        }\n      ",
    "searchText": "58  Feature: Athletes at the heart  More than 3,700 athletes have participated in at least one phase of the Business Accelerator, with 63 Olympians completing the entire programme to date – including diver Macarena Alexanderson, whose business aims to transform physical education for children in Mexico. “As athletes, we're often taught to not do things without preparing, and I think that is even more true in business,” she explains. “The Business Accelerator programme really helped to get my business started.” And for those athletes just getting going in their post-sporting career, the IOC offers various internship opportunities for Olympians to gain invaluable experience – right at the heart of the Olympic Movement. “It’s truly a dream come true,” says Italian rower and Athletes’ Department intern Valentina Iseppi, who competed in the women’s quadruple sculls at Tokyo 2020. “The opportunity to give back to sport and the Olympic community, after everything it’s given me, is one of the most fulfilling opportunities I've ever had.”  A bright future As President Bach prepares to step down from his role, leaving behind a legacy of increased representation, support and opportunities for athletes, the question now is: what does the future hold? Well, in IOC President-elect Kirsty Coventry, athletes have another Olympic champion and former IOC AC Chair to build on the progress made. In her manifesto, Coventry has “committed to serving athletes by maintaining open dialogue and ensuring their needs are prioritised”. How will she do this? “I will expand existing programmes and identify new opportunities for athletes to beneﬁt from our Olympic Partner Programme, Media Rights Holders, Olympic Solidarity and further develop athlete career programmes.” After a game-changing decade under President Bach, all signs point towards even more exciting times for athletes in the coming years. ■  1 Athletes could take part in recreational activities to earn pins and badges celebrating Paris 2024.  1  1  “I appreciate being part of a community that supports athletes between Games” MÁRTON KÉKESI, SKIING, HUNGARY"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 59,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg60.jpg",
    "zoom": null,
    "content": "\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 60,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg61.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 61-title-1\" style=\"top:447px;left:47px;\" src=\"/124/static/_content/61-title-1.png\"/>\n        <img class=\"abs halfScale 61-title-2\" style=\"top:594px;left:44px;\" src=\"/124/static/_content/61-title-2.png\"/>\n        <img class=\"abs halfScale 61-caption\" style=\"top:763px;left:55px;\" src=\"/124/static/_content/61-caption-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg61Anim = new TimelineMax();\n          pg61Anim.fromTo(cOf(\"61-title-1\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"61-title-2\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n          .fromTo(cOf(\"61-caption\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)\n        }\n\n        function onPageLeave() {\n          pg61Anim.stop();\n        }\n      ",
    "searchText": "The IOC is committed to ensuring athletes can train and compete in a safe sporting environment.  CHANGING THE SYSTEM  OVER THE PAST TWO DECADES, THE IOC HAS TAKEN MAJOR STEPS TO EMBED SAFEGUARDING ACROSS THE OLYMPIC MOVEMENT, BUILDING SYSTEMS, SUPPORTING ATHLETES AND WORKING TO ENSURE SAFER ENVIRONMENTS AT EVERY LEVEL OF SPORT. BY MICHAEL STONEMAN"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 61,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg62.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 62-quote\" style=\"top:558px;left:469px;\" src=\"/124/static/_content/62-quote-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg62Anim = new TimelineMax();\n          pg62Anim.fromTo(cOf(\"62-quote\"), 0.6, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg62Anim.stop();\n        }\n      ",
    "searchText": "62  Feature: Athlete safeguarding  “  I  ’ll never know what I could have achieved,” reﬂects Gloria Viseras from Spain, as she looks back on a sporting career that bears the weight of something no athlete should have to carry. Viseras was just 15 years old when she stepped onto the ﬂoor at the Olympic Games Moscow 1980 – a gifted gymnast representing her country on the world’s biggest sporting stage. But behind the poise of her performances in the Olympic spotlight was a hidden truth: Viseras was a survivor of severe abuse, suffering in silence at the hands of someone she was supposed to trust. “I trained while being abused. I was focused not on developing my skills, but on managing that abuse,” she recalls. “I was very talented. But I’ll never know what I could have done without the abuse. Of course, I was broken.” Back then, safeguarding simply didn’t exist in sport. There were no protocols, no reporting mechanisms and no one trained to recognise the signs that Viseras’s coach was abusing her. And for that broken 15-year-old girl, there was no safe space to speak out. “I didn’t know how to reach out for help. Nobody taught me. Nobody encouraged me to,” she says. “And when my parents asked me what was wrong, it was easier for me to say that I had had a tough workout than to explain what my coach was doing to me. “Perpetrators know how to keep victims silent and in secrecy – and they’re very good at it. They manipulate not only the victim, but also the whole environment around them.” For 30 years, Viseras kept her story to herself. When she ﬁnally disclosed it, the trauma of the court proceedings nearly broke her again. But it was during that time – facing threats and backlash – that she decided to act. “That’s when I decided I needed to work on this topic, to keep athletes from having to go through what I’ve gone through, and to be an advocate,” she says. Today, Viseras is the Senior Manager for Safeguarding in the IOC’s Health, Medicine and Science Department. She is at the heart of efforts to protect athletes through education, policy and a culture of trust. And for her, this work is more than a mission – it’s part of her own recovery. “For me, it’s very healing,” she says. “Because I see how my work is contributing  1  to keeping athletes safe, and to helping them when the damage has already been done. That’s what drives me forward.”  From silence to strategy For too long, stories like Viseras’s existed in silence. The topic of abuse in sport was often overlooked – considered too difficult, too uncomfortable or too damaging to the image of sport to be addressed openly. But that silence came at a cost. And as survivors began to speak out, their voices pushed sport to confront a reality it could no longer ignore. At the IOC, work on athlete safeguarding began in the early 2000s, with the publication of the first consensus statements and education tools. But the real shift in pace and priority came in 2016, when the organisation introduced its first Games-time Safeguarding Framework – a structured response to harassment and abuse at Olympic events  “I was very talented. But I’ll never know what I could have done without the abuse. Of course, I was broken” GLORIA VISERAS, IOC SENIOR MANAGER FOR SAFEGUARDING  – and launched the IOC Toolkit to help International Federations (IFs) and National Olympic Committees (NOCs) develop policies and procedures of their own. “Back in the late 1990s to early 2000s, safeguarding in the context of sport was something that was just not discussed, and was highly taboo, despite how widespread an issue it is across society,” explains Kirsty Burrows, the IOC’s Associate Director for"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 62,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg63.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink abs\" style=\"top:476px; left:468px; width:48px; height:12px;\">\n          <a href=\"https://www.olympics.com/ioc/safe-sport\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "63  Health, Medicine and Science. “Early pioneers and thought leaders in this space brought this to the IOC, and it was clear that proactive leadership from the IOC was needed. “We began working on safeguarding in 2004. The first consensus was in 2007, followed by a number of educational tools and awareness-raising programmes. The Games-time Framework came in 2016, along with guidelines for sports organisations, and the IOC Athlete Safeguarding Toolkit was launched in 2017, though we were working on it since late 2015.” The 2016 Larry Nassar case, and other high-profile abuse scandals, were also pivotal in shifting public awareness. For the IOC, these moments reinforced the importance of preparation – and the bravery of those who made their voices heard. “We must always recognise the courage of victims who spoke out,” says Burrows. “That created a wider awareness. There were so many misconceptions before – like ‘This only happens in certain sports’, or ‘Only to girls’, or ‘Only in certain countries’. But those voices helped shatter those misconceptions. Harassment and abuse permeates all aspects of society and can impact anyone; measures must look at protecting all individuals, across the board. “When that heightened recognition hit, our toolkit was ready to launch – after 18 months  2  of work with global experts. So we weren’t reacting – we were in a position to support athletes, with crucial guidance to sports organisations on safeguarding in sport. That’s something we’re proud of and that is really important in this space – not waiting for the crisis but building systems in advance.” That preparation proved critical because the foundations throughout the Olympic Movement were still extremely limited. “When I arrived in 2015, only one IF had a safeguarding statement that we could find,” recalls Burrows. Since then, progress has been driven by a clear mandate from the top. Under the leadership of IOC President Thomas Bach, safeguarding has moved from the margins to the mainstream of sport governance – and has been embedded across the Olympic Movement as part of Olympic Agenda 2020+5. “When we started, safeguarding wasn’t a strategic priority,” says Burrows. “Now it has its own section in the Olympic Charter. That shift – placing safeguarding at the heart of the Olympic Movement – has changed everything.” In 2022, the IOC established a dedicated Safe Sport Unit to lead this work year-round and at Games-time. The unit works across all IOC departments, and with partners throughout the Olympic Movement, to develop systems that are athlete-centred, trauma-informed and grounded in evidence, following a public health approach. Through updated frameworks, international training programmes and a growing network of trained professionals, safeguarding is no longer just about responding to incidents; it’s about changing the culture of sport. The shift has been significant. Today, all Olympic IFs have a designated safeguarding officer. Nearly nine in 10 have formal policies in place – and more importantly, they are being implemented and monitored. Through biannual reviews, needs assessments and hands-on guidance, safeguarding has shifted from being a document to becoming part of the daily culture of sport.  1 IOC President Thomas Bach addresses IF representatives at a safe sport conference. 2 Kirsty Burrows (left) and Gloria Viseras are leading the IOC’s work on safeguarding."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 63,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg64.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 64-quote\" style=\"top:505px;left:469px;\" src=\"/124/static/_content/64-quote-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg64Anim = new TimelineMax();\n          pg64Anim.fromTo(cOf(\"64-quote\"), 0.6, {opacity:0, x:10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg64Anim.stop();\n        }\n      ",
    "searchText": "64  Feature: Athlete safeguarding  “A policy alone doesn’t create cultural change,” says Burrows. “We look at broader indicators – not just whether a federation has a safeguarding policy and a focal point, but how safeguarding is embedded more holistically.”  From policy to practice Measuring progress in safeguarding means more than counting policies; it means understanding how systems are changing – and how trust is being rebuilt. Since 2016, the IOC has worked to ensure that safeguarding is not only adopted but embedded across the Olympic Movement. Through regular needs assessments, NOC reviews and athlete feedback surveys, progress is now being tracked in ways that reflect not just structure, but culture. “We’ve moved beyond just asking, ‘Do you have a policy?’ to developing comprehensive indicators,” explains Burrows. “From our 2022 to 2025 Needs Assessments, we’ve seen significant progress across all indicators. This shows that sports organisations are not only writing policies and training people, but they’re also strengthening safeguarding environments – with our support.” The results are plain to see. In the 2022 IF needs assessment, 85 per cent of Olympic IFs reported having a safeguarding policy in place. By 2025, that number had grown slightly but, more significantly, the proportion of IFs reporting full implementation rose from 56 to 82 per cent. In the same period, 197 NOCs completed the IOC’s NOC Review, with more than half confirming they had a safeguarding officer trained or enrolled in the IOC Certificate: Safeguarding Officer in Sport programme – a dedicated education and training initiative that has had a remarkable impact on building capacity across the Olympic ecosystem. Launched in 2021, it is the most comprehensive training programme of its kind: a 250-hour course delivered over seven months, designed by a global academic advisory board. To date, 343 participants from 99 countries have followed the course, with strong representation from IFs, NOCs, National Federations and grassroots clubs. Many of these participants were supported by Olympic Solidarity funding, as part of the IOC’s commitment to equitable access. But these numbers only tell part of the story – the real measure of change lies in what athletes are seeing and feeling themselves.  1  At the Olympic Games Paris 2024, safeguarding support was more visible and accessible than ever before. The updated Games-time Safeguarding Framework was implemented with the support of 154 accredited welfare officers from 74 NOCs and 41 welfare focal points from 32 IFs, all of whom were available on-site to support athletes and teams. These professionals were trained to recognise concerns, offer trauma-informed support and coordinate follow-up care if needed. Inside the Olympic Village, athletes found the Athlete365 Mind Zone x Powerade, a new initiative developed with Worldwide Olympic Partner Coca-Cola. Designed as a space to decompress and recharge, the Mind Zone offered evidence-based mindfulness activities, access to trained support staff and a quiet place to disconnect from competition pressures. More than 2,300 immersive virtual reality (VR) mindfulness sessions were delivered to athletes and entourage members from 148 countries, and more than 4,000 “gratitude postcards” sent to loved ones.  “Placing safeguarding at the heart of the Olympic Movement... has changed everything” KIRSTY BURROWS, IOC ASSOCIATE DIRECTOR FOR HEALTH, MEDICINE AND SCIENCE  But beyond these numbers, the Mind Zone provided a different kind of entry point – one that normalised care, created space for honest conversations and offered support in a way that felt safe and approachable. “We provided a safe space for the athletes to come and reach out for help,” says Viseras. “And in a lot of those conversations – when they came and said things like, ‘I’m just not feeling well’ – we were able to identify underlying issues and refer them to specialists for support.” Safeguarding was also extended into the digital space. For the first time, the IOC implemented a full-scale cyber abuse"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 64,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg65.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  65  Issue 124  And that shift is essential – not only for those competing today, but for the next generation. “A massive survey of over 10,000 young athletes and their parents found that fear of harassment and abuse is one of the top reasons parents don’t want their children in sport,” says Burrows. “So safeguarding is critical to the sustainability of sport and the Olympic Movement.” The changes are measurable but their most important impact is the one that can’t be easily quantified: a growing sense that athletes are no longer alone. “Every time we’re able to help an athlete with a concern, it’s super rewarding,” explains Viseras. “You can see a policy being developed and implemented, but there’s nothing like actually helping a person face-to-face with an issue, as we do at the Olympic and Youth Olympic Games.”  From sport to society  2  protection service, using AI to monitor more than 2.4 million social media posts in over 35 languages. In cases where athletes or officials were targeted with abuse – more than 350 individuals in total – the system enabled rapid action. Content that breached platform guidelines was removed, while content that appeared potentially criminal was escalated to the relevant authorities. At the Winter Youth Olympic Games (YOG) Gangwon 2024, this broader safeguarding strategy was adapted for a younger audience. In addition to welfare officers and safeguarding education, the “Mind, Body and Me” zone offered holistic well-being activities to help normalise conversations around mental health and injury prevention. A post-Games survey, completed by more than 1,200 athletes, revealed that 76 per cent were aware of the IOC’s safeguarding measures, and 80 per cent felt comfortable reaching out for help. This trust – and the willingness to use the systems in place – are one of the clearest signs that progress is taking root. “Trust is earned in droplets and lost in buckets,” says Burrows. “That trust – that willingness to engage with our systems – is the most important metric we have.” Education has also become a key tool for change. In August 2023, the IOC launched  two new online courses on Athlete365: Safeguarding Essentials for Young Athletes and Safeguarding Essentials for Athlete Allies. Available in 10 languages, the courses help young athletes and their entourage understand the different forms of abuse, how to recognise warning signs and how to take appropriate action. Both were developed in response to the needs identified by athletes themselves. Meanwhile, the Safeguarding Focal Point Course – first delivered to IOC Athletes’ Commission members in 2022 and expanded in 2023 – is helping athlete representatives provide peer-level support, while strengthening the safeguarding knowledge base across the Olympic Movement. A train-the-trainer programme for this course, which ensures the initiative can be tailored to local contexts, is set to be launched in June 2025. What emerges from all of these efforts is not just a network of policies or interventions, but a shift in mindset. Athletes are speaking up. Organisations are listening. And safeguarding is no longer something done behind closed doors or in response to crisis. It is becoming part of how teams are formed, how competitions are run and how safe sporting environments are sustained.  The IOC’s work on safeguarding has always been rooted in the needs of athletes. But in recent years, its focus has expanded – from preventing harm in sport to contributing to safer systems across society. One of the clearest examples of this shift is the development of Safe Sport Regional Hubs, a new initiative designed to build stronger, community-led safeguarding networks in partnership with local stakeholders. Supported by a quadrennial USD 10 million fund and developed in collaboration with experts, survivors and public agencies, the hubs aim to meet the needs of athletes and others who have been harmed in sport – not just during competitions, but across their full sporting journey. Two pilot hubs are now underway – one in Southern Africa and another in the Pacific Islands. Each is being shaped by regional consortia, including civil society organisations, safeguarding practitioners, government bodies and academic institutions. These hubs are intended to support reporting and response, as well as prevention, education, referral systems and survivor services that reflect local realities.  1 A safe sport space for athletes is now a regular feature in the Olympic Village. 2 IOC President Thomas Bach tries out a VR headset at the Winter YOG Gangwon 2024."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 65,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg66.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 66-quote\" style=\"top:106px;left:469px;\" src=\"/124/static/_content/66-quote-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg66Anim = new TimelineMax();\n          pg66Anim.fromTo(cOf(\"66-quote\"), 0.6, {opacity:0, y:-10}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg66Anim.stop();\n        }\n      ",
    "searchText": "66  Feature: Athlete safeguarding  “It shouldn’t be on the athlete to disclose abuse. It’s the environment that needs to be safe” GLORIA VISERAS, IOC SENIOR MANAGER FOR SAFEGUARDING  1  “Rather than just setting up an office and planting an IOC flag, we’re taking a localised, community-driven approach,” explains Burrows. “Each hub will be different because it’s by the region, for the region.” The hubs are part of a broader rethinking of how the IOC sees its role – not just as a convenor of sport, but as a partner in global safeguarding efforts. Increasingly, the IOC is working with organisations such as the World Health Organization (WHO), UNICEF and the United Nations Office on Drugs and Crime (UNODC) to develop cross-sector approaches that support athletes and strengthen child protection systems more broadly. “Sport doesn’t exist in a vacuum,” Burrows says. “We’re not just strengthening safeguarding in sport – we’re recognising that sport can be a vehicle for protection at a much wider level.” To support this wider ambition, the IOC has helped establish an International Safe Sport Steering Committee, bringing together intergovernmental organisations, NGOs, athlete representatives and sport bodies. The committee is guiding the development of global tools, including an International Safe Sport Framework, a classification system for interpersonal violence in sport and guidelines for trauma-informed investigations. These tools, while designed for sport, have the potential to inform how safeguarding is  understood and implemented in schools, clubs and youth organisations worldwide – wherever young people learn, train or compete. “Violence against children is a global societal issue,” says Burrows. “Sport, over the last 10 years under President Bach’s leadership, has become a sector that’s not just addressing violence within itself, but helping address violence in society through sport-based programmes. We are seeing a shift in people and organisations seeing sport as a powerful driver of systems change.” At its core, this approach reflects the same principle that has guided the IOC’s work from the start: that sport must be a safe space. But increasingly, it’s also recognising that sport can be part of the solution – not only for athletes, but for society.  From pain to purpose Gloria Viseras knows that safeguarding can’t undo the past. But it can change what athletes experience today, equipping them with the tools and support to act when something is wrong. “Athletes need to know that there is help available now,” she says. “They can reach out if something doesn’t feel right. They can ask questions. They can challenge misbehaviours. There will always be someone who will help. The topic is on the table. Organisations are working on it. Awareness has been raised.  There is far, far more help than there used to be.” From a time when safeguarding wasn’t even a concept to a moment when it is becoming embedded in the fabric of sport, the shift is real. The work isn’t finished – and the change hasn’t come overnight – but across the Olympic Movement, there is now a shared commitment to safer sport. And as the work continues, Viseras is clear about what’s needed next. “Safeguarding is everyone’s responsibility,” she says. “We need allies to ensure that environments are safe, so that athletes can get the full benefit of participating in sport, and have a good, long-lasting experience at all levels. We need people – everyone – as safeguarding allies. Because it’s everyone’s responsibility.” That shared responsibility, she explains, is about shifting the burden away from the athlete – and onto the systems meant to protect them. “Really, it shouldn’t be on the athlete to disclose abuse,” she adds. “It’s the environment that needs to be safe. It’s the responsibility of those around the athlete to keep them safe.” For Viseras, that responsibility is personal – but it’s also a promise. “I made peace with it – when I realised that it wasn’t sport itself. It was some people within sport who made that abuse happen,” she says. “It wasn’t the sport.” And while Viseras still lives with unanswered questions about what might have been, the IOC’s safeguarding efforts are helping ensure that no other athlete has to suffer in silence, denied the chance to reach their full potential. ■  1 During the Games, athletes can take part in education programmes and focus on their well-being in a supportive environment."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 66,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg67.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "omegawatches.com  OFFICIAL TIMEKEEPER With one leap towards history, OMEGA counts down the hours, minutes, and seconds to the Olympic and Paralympic Winter Games 0LODQR &RUWLQD  $V 2IƸFLDO 7LPHNHHSHU 20(*$ ZLOO FDSWXUH more than just time — it will capture every heartbeat, every recordEUHDNLQJPRPHQWDQGHYHU\GUHDPVHWLQWRPRWLRQ  SEAMASTER MILANO CORTINA 2026 Co-Axial Master Chronometer"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 67,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg68.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 68-icon\" style=\"top:128px;left:2px;\" src=\"/124/static/_content/68-icon-1.png\"/>\n        <img class=\"abs halfScaleC 68-icon\" style=\"top:234px;left:100px;\" src=\"/124/static/_content/68-icon-2.png\"/>\n        <img class=\"abs halfScaleC 68-icon\" style=\"top:358px;left:23px;\" src=\"/124/static/_content/68-icon-3.png\"/>\n        <img class=\"abs halfScaleC 68-icon\" style=\"top:462px;left:211px;\" src=\"/124/static/_content/68-icon-4.png\"/>\n        <img class=\"abs halfScaleC 68-icon\" style=\"top:594px;left:305px;\" src=\"/124/static/_content/68-icon-5.png\"/>\n        <img class=\"abs halfScaleC 68-icon\" style=\"top:526px;left:491px;\" src=\"/124/static/_content/68-icon-6.png\"/>\n\n        <img class=\"abs halfScale 68-text-1\" style=\"top:199px;left:165px;\" src=\"/124/static/_content/68-text-1.png\"/>\n        <img class=\"abs halfScale 68-text-2\" style=\"top:285px;left:262px;\" src=\"/124/static/_content/68-text-2.png\"/>\n        <img class=\"abs halfScale 68-text-3\" style=\"top:442px;left:185px;\" src=\"/124/static/_content/68-text-3.png\"/>\n        <img class=\"abs halfScale 68-text-4\" style=\"top:558px;left:97px;\" src=\"/124/static/_content/68-text-4.png\"/>\n        <img class=\"abs halfScale 68-text-5\" style=\"top:758px;left:333px;\" src=\"/124/static/_content/68-text-5.png\"/>\n        <img class=\"abs halfScale 68-text-6\" style=\"top:691px;left:556px;\" src=\"/124/static/_content/68-text-6.png\"/>\n        \n        <img class=\"abs halfScale 68-line-1\" style=\"top:270px;left:127px;\" src=\"/124/static/_content/68-line-1.png\"/>\n        <img class=\"abs halfScale 68-line-2\" style=\"top:381px;left:154px;\" src=\"/124/static/_content/68-line-2.png\"/>\n        <img class=\"abs halfScale 68-line-3\" style=\"top:478px;left:167px;\" src=\"/124/static/_content/68-line-3.png\"/>\n        <img class=\"abs halfScale 68-line-4\" style=\"top:580px;left:353px;\" src=\"/124/static/_content/68-line-4.png\"/>\n        <img class=\"abs halfScale 68-line-5\" style=\"top:654px;left:454px;\" src=\"/124/static/_content/68-line-5.png\"/>\n        <img class=\"abs halfScale 68-line-6\" style=\"top:543px;left:629px;\" src=\"/124/static/_content/68-line-6.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg68Anim = new TimelineMax();\n          pg68Anim.staggerFromTo(cOf(\"68-icon\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1)\n          .fromTo(cOf(\"68-line-1\"), 0.6, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.1)\n          .fromTo(cOf(\"68-line-2\"), 0.6, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.2)\n          .fromTo(cOf(\"68-line-3\"), 0.6, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n          .fromTo(cOf(\"68-line-4\"), 0.6, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)\n          .fromTo(cOf(\"68-line-5\"), 0.6, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.5)\n          .fromTo(cOf(\"68-line-6\"), 0.6, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n\n          .fromTo(cOf(\"68-text-1\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.1)\n          .fromTo(cOf(\"68-text-2\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n          .fromTo(cOf(\"68-text-3\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n          .fromTo(cOf(\"68-text-4\"), 0.6, {opacity:0, x:-50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)\n          .fromTo(cOf(\"68-text-5\"), 0.6, {opacity:0, y:50}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.5)\n          .fromTo(cOf(\"68-text-6\"), 0.6, {opacity:0, y:50}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.6)\n        }\n\n        function onPageLeave() {\n          pg68Anim.stop();\n        }\n      ",
    "searchText": "68  Feature: Athlete safeguarding  THE ROAD TO SAFER SPORT 2004  IOC begins formal work on athlete safeguarding, initiating research and consultation on harassment and abuse in sport.  2007 2014  First IOC Consensus Statement on Sexual Harassment and Abuse in Sport published ñ a foundational step in defining the problems, identifying the risk factors and providing guidelines for prevention and resolution.  IOC Safe Sport Working Group established.  IOC Games-time Safeguarding Framework introduced at the Olympic Games Rio 2016 ñ marking the first time a formal safeguarding system is deployed at an Olympic Games. IOC Guidelines for IFs and NOCs on athlete safeguarding published. Second IOC Consensus Statement on Harassment and Abuse in Sport published, expanding the scope to include physical abuse, psychological abuse, neglect and hazing, while also introducing the definition of ìsafe sportî, emphasising the need for safe sporting environments at all levels of athletic participation.  2016 2019 2017 IOC Safeguarding Toolkit for IFs and NOCs launched, providing practical guidance for organisations to develop and implement safeguarding policies and procedures.  IOC Consensus Statement on Mental Health in Elite Athletes released, further embedding athlete well-being into the safeguarding conversation."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 68,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg69.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 69-icon\" style=\"top:448px;left:-4px;\" src=\"/124/static/_content/69-icon-1.png\"/>\n        <img class=\"abs halfScaleC 69-icon\" style=\"top:544px;left:157px;\" src=\"/124/static/_content/69-icon-2.png\"/>\n        <img class=\"abs halfScaleC 69-icon\" style=\"top:378px;left:241px;\" src=\"/124/static/_content/69-icon-3.png\"/>\n        <img class=\"abs halfScaleC 69-icon\" style=\"top:198px;left:318px;\" src=\"/124/static/_content/69-icon-4.png\"/>\n        <img class=\"abs halfScaleC 69-icon\" style=\"top:342px;left:451px;\" src=\"/124/static/_content/69-icon-5.png\"/>\n\n        <img class=\"abs halfScale 69-text-1\" style=\"top:611px;left:52px;\" src=\"/124/static/_content/69-text-1.png\"/>\n        <img class=\"abs halfScale 69-text-2\" style=\"top:705px;left:226px;\" src=\"/124/static/_content/69-text-2.png\"/>\n        <img class=\"abs halfScale 69-text-3\" style=\"top:518px;left:378px;\" src=\"/124/static/_content/69-text-3.png\"/>\n        <img class=\"abs halfScale 69-text-4\" style=\"top:252px;left:481px;\" src=\"/124/static/_content/69-text-4.png\"/>\n        <img class=\"abs halfScale 69-text-5\" style=\"top:505px;left:503px;\" src=\"/124/static/_content/69-text-5.png\"/>\n        \n        <img class=\"abs halfScale 69-line-1\" style=\"top:543px;left:-78px;\" src=\"/124/static/_content/69-line-1.png\"/>\n        <img class=\"abs halfScale 69-line-2\" style=\"top:550px;left:144px;\" src=\"/124/static/_content/69-line-2.png\"/>\n        <img class=\"abs halfScale 69-line-3\" style=\"top:525px;left:293px;\" src=\"/124/static/_content/69-line-3.png\"/>\n        <img class=\"abs halfScale 69-line-4\" style=\"top:316px;left:329px;\" src=\"/124/static/_content/69-line-4.png\"/>\n        <img class=\"abs halfScale 69-line-5\" style=\"top:344px;left:429px;\" src=\"/124/static/_content/69-line-5.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg69Anim = new TimelineMax();\n          pg69Anim.staggerFromTo(cOf(\"69-icon\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.6)\n          .fromTo(cOf(\"69-line-1\"), 0.6, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n          .fromTo(cOf(\"69-line-2\"), 0.6, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.7)\n          .fromTo(cOf(\"69-line-3\"), 0.6, {opacity:0, y:-30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.8)\n          .fromTo(cOf(\"69-line-4\"), 0.6, {opacity:0, y:-30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.9)\n          .fromTo(cOf(\"69-line-5\"), 0.6, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2)\n\n          .fromTo(cOf(\"69-text-1\"), 0.6, {opacity:0, y:50}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.6)\n          .fromTo(cOf(\"69-text-2\"), 0.6, {opacity:0, y:50}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.7)\n          .fromTo(cOf(\"69-text-3\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.8)\n          .fromTo(cOf(\"69-text-4\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.9)\n          .fromTo(cOf(\"69-text-5\"), 0.6, {opacity:0, y:50}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2)\n        }\n\n        function onPageLeave() {\n          pg69Anim.stop();\n        }\n      ",
    "searchText": "Olympic Review  69  Issue 124  2023  Olympic Agenda 2020+5 includes Recommendation 5, formally embedding safeguarding and mental health support as core IOC priorities.  Establishment of the IOC Safe Sport Unit within the Health, Medicine and Science Department.  2021 Launch of the IOC Certificate: Safeguarding Officer in Sport, creating a global network of trained safeguarding professionals.  Work begins on Safe Sport Regional Hubs in Southern Africa and the Pacific Islands.  2024  2022 2020  IOC announces USD 10 million safeguarding fund for local-level initiatives.  Games-time safeguarding and well-being infrastructure expanded at Paris 2024 and Winter YOG Gangwon 2024, including the Athlete365 Mind Zone x Powerade, AI-powered cyber abuse monitoring system and dedicated welfare officers. IOC Interactive Safeguarding Directory launched. Third IOC Consensus Statement on Interpersonal Violence and Safeguarding in Sport published in the British Journal of Sports Medicine."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 69,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg70.jpg",
    "zoom": null,
    "content": "\n\n        <img class=\"abs halfScale 70-title\" style=\"top:54px;left:47px;\" src=\"/124/static/_content/70-title-1.png\"/>\n        <img class=\"abs halfScale 70-title\" style=\"top:163px;left:44px;\" src=\"/124/static/_content/70-title-2.png\"/>\n        <img class=\"abs halfScale 70-caption\" style=\"top:301px;left:43px;\" src=\"/124/static/_content/70-caption-1.png\"/>\n        <img class=\"abs halfScale 70-caption\" style=\"top:436px;left:43px;\" src=\"/124/static/_content/70-caption-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg70Anim = new TimelineMax();\n          pg70Anim.staggerFromTo(cOf(\"70-title\"), 0.6, {opacity:0, x:100}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.1, 1)\n          .staggerFromTo(cOf(\"70-caption\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.4)\n        }\n\n        function onPageLeave() {\n          pg70Anim.stop();\n        }\n      ",
    "searchText": "MORE THAN JUST A TEAM NEARLY A DECADE AFTER ITS FIRST APPEARANCE, THE IOC REFUGEE OLYMPIC TEAM IS NOW AN ESTABLISHED FEATURE AT THE OLYMPIC GAMES AND HAS IMPACTED SPORT AT ALL LEVELS. BY NANCY GILLEN  Members of the IOC Refugee Olympic Team compete in the judo mixed team event at Paris 2024."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 70,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg71.jpg",
    "zoom": null,
    "content": "\n      \n        <!--Gallery-->\n        <img class=\"abs halfScaleC halfpulse animatedpulse pointer\"\n        style=\"top:760px; left:600px;\"\n        onclick=\"pg71_gallery(0)\"\n        src=\"/124/static/_content/white-camera.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 71,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg72.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink abs\" style=\"top:250px; left:208px; width:19px; height:11px;\">\n          <a href=\"https://www.olympics.com/ioc/refugee-olympic-team\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink abs\" style=\"top:264px; left:42px; width:101px; height:11px;\">\n          <a href=\"https://www.olympics.com/ioc/refugee-olympic-team\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "72  Feature: IOC Refugee Olympic Team  T  he Maracanã Stadium was a spectacle of noise and colour when it hosted the Olympic Games Rio 2016 Opening Ceremony, but there was one memorable moment that sparked the loudest cheers of all. As the Athletes’ Parade came to an end, 10 athletes, originally hailing from Ethiopia, South Sudan, Syria and the Democratic Republic of the Congo, proudly walked into the stadium beneath the Olympic flag. Together, they formed the first-ever IOC Refugee Olympic Team, an initiative announced by International Olympic Committee (IOC) President Thomas Bach at the United Nations (UN) General Assembly in October 2015. Their presence was a powerful response to the global refugee crisis, which had seen millions of people displaced. In the words of President Bach, the athletes represented “a symbol of hope for all the refugees in our world”. Now, nearly a decade later, the IOC Refugee Olympic Team has grown in both size and significance, as the IOC continues to support refugees and populations affected by displacement – one of the recommendations of the Olympic Agenda 2020+5 reforms. More athletes have joined the team’s ranks with each Olympic cycle, from 29 athletes  1  at the Olympic Games Tokyo 2020 to 37 athletes at the Olympic Games Paris 2024, while a IOC Refugee Youth Olympic Team will make its first appearance at the Youth Olympic Games Dakar 2026. This has inspired many International Federations to include refugee teams in their own competitions, with 16 in total amending their regulations to allow refugee athletes to participate. These athletes are supported in their pursuit of an elite sporting career by the Refugee Athlete Support Programme, which is overseen by the Olympic Refuge Foundation (ORF). Leading up to Paris 2024, the programme supported 74 athletes from 24 countries and across 13 sports. Through scholarships funded by Olympic Solidarity, the athletes were able to train and compete in high-level competitions. The scholarship-holders included Cindy Ngamba, who made history when she won bronze in the women’s -75kg boxing competition and earned the IOC Refugee Olympic Team’s first-ever Olympic medal. Among those celebrating Ngamba’s historic achievement was Cyrille Tchatchet, a former member of the IOC Refugee Olympic Team who worked as a welfare officer for the athletes at Paris 2024.  2  3"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 72,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg73.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 73-quote\" style=\"top:585px;left:255px;\" src=\"/124/static/_content/73-quote-1.png\"/>\n\n        <a href=\"https://www.youtube.com/watch?v=HP8z5ZWOzW8\" target=\"_blank\"><img class=\"halfScaleC halfpulse animatedpulse pointer z-index-set\" src=\"/124/static/_content/play-btn.png\" style=\"top:179px;left:289px;\" /></a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg73Anim = new TimelineMax();\n          pg73Anim.fromTo(cOf(\"73-quote\"), 0.6, {opacity:0, y:10}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg73Anim.stop();\n        }\n      ",
    "searchText": "Olympic Review  73  Issue 124  “Being part of the IOC Refugee Olympic Team changed my life. It gave me the opportunity to become an Olympian” CYRILLE TCHATCHET, IOC REFUGEE OLYMPIC TEAM  1 The IOC Refugee Olympic Team joins the Athletes’ Parade at the Rio 2016 Opening Ceremony. 2 Cyrille Tchatchet was one of 29 athletes to represent the IOC Refugee Olympic Team at Tokyo 2020. 3 At Paris 2024, boxer Cindy Ngamba (right) became the team’s ﬁrst-ever medallist.  Tchatchet arrived in Great Britain from Cameroon in 2014 and sought asylum. During the challenging wait for his application to be processed, he found solace in weightlifting. A few years later, he was granted refugee status and began rebuilding his life in his new country. Through the Refugee Athlete Support Programme, Tchatchet was able to train and compete in weightlifting at an elite level. He was chosen to represent the IOC Refugee Olympic Team at Tokyo 2020 and finished 10th in his event. “Seeing Cindy Ngamba win that Olympic medal was a big moment for the IOC Refugee Olympic Team and for refugees around the world,” Tchatchet says. “It showed that while life for a refugee can be difficult, we all take different paths to greatness. “I think Cindy showcased the power of sport. She showcased resilience. She showcased courage. That was very powerful for us. I was personally so glad to be a part of that team and it was an honour to celebrate together.” Now a community psychiatric nurse, Tchatchet’s journey shows how much of an impact sport can have on a displaced person’s life. “Sport has provided me with everything,” he says. “When I arrived in the UK as a teenager, I had nothing. And sport in general, weightlifting in particular, provided me with the space to meet new people, to make friends, to learn the culture and the language of the country I had arrived in. “Being a part of the IOC Refugee Olympic Team changed my life. It gave me the opportunity to become an Olympian, which was a lifelong dream as an athlete.” The ORF does not just focus on elite athletes. The foundation was established by the IOC in September 2017 to support the protection, development and empowerment of children and young people in vulnerable situations through sport. Offering increased access to sport 365 days a year, the ORF supports programmes that use sport to improve the well-being and social inclusion of displaced youth. One such programme is Game Connect in Uganda, a collaboration between the ORF, AVSI, Right to Play, Youth Sport Uganda, the Uganda Olympic Committee and UNHCR, the UN Refugee Agency. The initiative helps young refugees in four communities across"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 73,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg74.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 74-quote\" style=\"top:518px;left:255px;\" src=\"/124/static/_content/74-quote-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg74Anim = new TimelineMax();\n          pg74Anim.fromTo(cOf(\"74-quote\"), 0.6, {opacity:0, y:-10}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg74Anim.stop();\n        }\n      ",
    "searchText": "1  2  “Whatever sport we are playing, the youths will learn key life skills which will help them with their day-to-day challenges” LYDIA MURUNGI, GAME CONNECT  1 Game Connect in Uganda teaches its participants life skills through sports such as football. 2 A joint venture of the ORF and the French Sports Ministry, “Terrains d’Avenir” gives displaced young people access to sport. 3 A record 37 athletes represented the IOC Refugee Olympic Team at Paris 2024. 4 President Bach visits a sport and education centre for refugees in Doha, Qatar.  the country overcome challenges such as depression, anxiety and social isolation. “As of 2025, Uganda hosts more than 1.7 million refugees,” explains Game Connect Programme Manager Lydia Murungi. “It is the largest refugee population in Africa and the sixth largest in the world. “Of those 1.7 million refugees that are hosted in Uganda, over 24 per cent of them are youth between the ages of 15 and 24 from different nationalities. It's quite a big population. “One thing we’ve observed, especially for those who have stayed five years or more,  is they usually display a high rate of depression and anxiety disorders due to quite a number of factors – unemployment, poverty, a lack of social integration and a reduction in humanitarian assistance. “Of the youths we assess in the communities where we work, we find more than 92 per cent of them have certain forms of depression or anxiety, making them eligible for enrolment onto the programme.” With support from the ORF, Game Connect developed a structured curriculum that teaches life skills through sports such as football and volleyball. “Whatever sport we are playing, the youths will learn key life skills which will help them with their day-to-day challenges,” Murungi explains. “They build their social networks because they are interacting with other youths. It builds their cohesion. At the end of the day, they have a sense of belonging within the group. “They start off as strangers but ultimately, through the interactions and"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 74,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg75.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  75  Issue 124  the games that they get to play, they create friendships. They create a small community among themselves and they can support each other with the challenges they might be facing.” Participants complete a mental health assessment before and after the programme, with many showing significant improvements in confidence, well-being and social integration. Murungi recalls a particularly powerful transformation – that of a former child soldier from Sudan. “It was a very traumatic experience for him,” she says. “He came to Uganda. He was so lonely. He was living with his siblings, no parents, and they were basically fending for themselves. “His life was really very difficult. He would have outbursts and was always fighting with everybody. He joined the group but felt like it was a waste of time. He went three weeks without attending but then got bored. He decided to go back, so he could talk to people and play football. “There is a life skill we talk about – being accountable to other people for things that we do. That was his turning point. He became very emotional and remorseful over the things he had done and started going around making apologies to everyone he had wronged. “We started to see a lot of changes in him. He was smiling a bit, making friends, and he became one of our peer leaders, engaging other youths in the community. “It was very touching to see somebody coming from that whole trauma and that loneliness, bottling it up, affecting his own life and the lives of people around him, and then managing to turn around and change.” While initiatives like Game Connect change lives on the ground, the ORF is also working at an advocacy level to ensure the role of sport in supporting refugees is recognised and capitalised on worldwide. The ORF Think Tank plays a central role in this. It brings together academic experts, NGOs, UN agencies, youth representatives and the private and public sectors to develop evidence-based recommendations that inform policy and practice, and also demonstrate the value sport can bring to displaced people. “If you think about the different people and organisations represented within the Think  3  4"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 75,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg76.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "2  1  Tank, we can see it acts as a bridge between research, advocacy and real-world policy challenges,” explains Ajwang Warria, Co-Chair of the ORF Think Tank. “I've noticed the Think Tank is active at different moments in the life of the Olympic Refuge Foundation. We could be ‘policypreneurs’, we could be brokers of knowledge, we could be a centre of research, we could be an incubator of new ideas. “We’ve been able to think about and send out information that is credible, relevant and easily understood, just because of the multiplicity of thinking that actually happens within this space. I think we’re a think-and-do collective, not just a Think Tank.” A recent initiative was the “Think Sport. Think Refuge” podcast, which was launched for Paris 2024. By sharing insights from humanitarian programmes, training activities and research, the podcast aimed to encourage dialogue and debate on how sport can positively impact young refugees. “It wasn’t only to entertain, but it was also to educate and keep people informed about  the Olympic Games and how it can change people’s lives,” Warria says. Warria highlights Game Connect as one of the ORF’s success stories, before explaining exactly why sport is so beneficial to displaced youth. “When we think about migration and the impact that it has on a person, it’s not only the individual and their mental health, but it’s also about their families, the communities, the relationships and lots of multiple losses that they encounter,” she says. “Through sports, a young person can build a life of routine and regain control. They might also be able to create positive relationships with other young people, and sometimes with older, trusted people such as coaches. “Sport also takes place within supportive settings which sustain the young person’s inclusion. But it’s important for us not to think about this in a blinded way because sport can also be exclusionary, and that’s why it’s important for the Think Tank to be able to study specific experiences that the young people encounter, whether good or bad.  “Maybe programmes we implemented with good intentions turned out to be something else – how do we self-correct? It’s important to include persons with lived experience to help us think through this.” It is now even more pertinent to go back to the Rio 2016 Opening Ceremony and watch the IOC Refugee Olympic Team enter the Maracanã Stadium. In that moment, an idea came to fruition, one which has grown into a far-reaching initiative that touches every level of sport – from grassroots play in refugee settlements to podiums at the Olympic Games. “It shows [refugees] they matter,” Warria says. “It becomes a symbol of hope and shows inclusion is actually possible. It demonstrates that despite the war, conflict and different reasons for displacement, if somebody has a talent, then the talent knows no borders. It affirms the belief of a society where everybody can belong.” ■  1 The Olympic Refuge Foundation uses sport to help refugees at the Kakuma Refugee Camp in Kenya. 2 The “Think Sport. Think Refuge” podcast was launched during Paris 2024."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 76,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg77.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 77,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg78.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 78-title\" style=\"top:81px;left:42px;\" src=\"/124/static/_content/78-title-1.png\"/>\n        <img class=\"abs halfScale 78-caption\" style=\"top:145px;left:43px;\" src=\"/124/static/_content/78-caption-1.png\"/>\n\n        <div class=\"addContentLink\" style=\"top:810px;left:169px;width:139px;height:12px\">\n          <a href=\"mailto:studies.center@olympic.org\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:810px;left:314px;width:112px;height:12px\">\n          <a href=\"https://www.olympics.com/ioc/olympic-studies-centre\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:810px;left:432px;width:108px;height:12px\">\n          <a href=\"https://library.olympics.com/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:822px;left:180px;width:112px;height:12px\">\n          <a href=\"https://www.facebook.com/OlympicStudiesCentre\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:822px;left:300px;width:226px;height:12px\">\n          <a href=\"https://www.linkedin.com/showcase/olympic-studies-centre\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:337px;left:42px;width:147px;height:15px\">\n          <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/3533207/olympic-agenda-2020-5-closing-report-international-olympic-committee\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:355px;left:42px;width:70px;height:11px\">\n          <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/3533207/olympic-agenda-2020-5-closing-report-international-olympic-committee\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:337px;left:255px;width:147px;height:15px\">\n          <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/3532845/sustainability-legacy-post-games-report-strategic-focus-delivering-more-sustainable-games-paris-2024\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:354px;left:255px;width:122px;height:15px\">\n          <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/3532845/sustainability-legacy-post-games-report-strategic-focus-delivering-more-sustainable-games-paris-2024\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:337px;left:467px;width:113px;height:15px\">\n          <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/3416013/comparative-elite-sport-development-systems-structures-and-public-policy-ed-by-jonathan-grix-et-al\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:354px;left:467px;width:123px;height:15px\">\n          <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/3416013/comparative-elite-sport-development-systems-structures-and-public-policy-ed-by-jonathan-grix-et-al\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg78Anim = new TimelineMax();\n          pg78Anim.fromTo(cOf(\"78-title\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"78-caption\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg78Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "78  Olympic Studies  OLYMPiC STUDiES The latest book reviews from the IOC Olympic Studies Centre – your source of Olympic knowledge  OLYMPIC AGENDA 2020+5: CLOSING REPORT  The Olympic Agenda reforms have profoundly transformed the IOC, the Olympic Games and the Olympic Movement. Introduced under the motto “Change or be changed”, this visionary programme, initiated by IOC President Thomas Bach, was unanimously approved by the 127th IOC Session in Monaco in December 2014. In 2021, Olympic Agenda 2020+5 succeeded Olympic Agenda 2020. It consists of 15 recommendations based on ﬁve key trends identiﬁed as areas where sport and Olympism had a vital role to play in a post-pandemic world. This closing report is structured in two parts. The ﬁrst highlights the major achievements of the reforms through 10 key topics, while the second provides an in-depth analysis of the 15 recommendations. Taken together, these elements showcase the profound impact of these reforms on the future of the Olympic Movement.  PUBLiSHED BY: International Olympic Committee, 2025, 182 pages, in English.  SUSTAINABILITY & LEGACY POST-GAMES REPORT:  STRATEGIC FOCUS – DELIVERING MORE SUSTAINABLE GAMES: PARIS 2024 The Olympic Games Paris 2024 were the ﬁrst to be fully aligned with Olympic Agenda 2020, setting new benchmarks for sustainability and legacy. The post-Games report details the strategies, methods and tools used by the Organising Committee to reduce the Games’s footprint while creating lasting beneﬁts to local communities. It highlights how, with support from key stakeholders, sustainability was successfully integrated into every decision. By adopting innovative energy solutions, limiting new construction and promoting a circular economy, Paris 2024 signiﬁcantly reduced its environmental impact. At the same time, strong social initiatives made meaningful contributions to the community. Now that the Games are over, this report underscores how these efforts set a new standard for future editions, leaving a lasting legacy for generations to come.  PUBLiSHED BY: Organising Committee for the Olympic and Paralympic Games Paris 2024, 2024, 534 pages, in English and French.  COMPARATIVE ELITE SPORT DEVELOPMENT:  SYSTEMS, STRUCTURES AND PUBLIC POLICY This book offers a new and in-depth analysis of elite sport systems worldwide, analysing policies and programmes in 20 countries that have achieved international success. Building on the ﬁrst edition published in 2008, it expands the scope with 13 new country case studies for a broader global perspective. Each chapter explores the political, historical and economic context shaping these nations’ sport systems. The authors examine the rationale behind government investments in elite sport, the organisation and funding of sport development, the impact on grassroots participation in sport and the role of mega-events like the Olympic Games in shaping national sport policies. This collection of case studies provides a valuable understanding of the strategies behind global sporting success.  EDITED BY: Jonathan Grix, Paul Michael Brannagan, Barrie Houlihan. PUBLiSHED BY: Routledge, 2025, ISBN 9781032100777, 352 pages, in English.  FIND OUT MORE For historical, factual information and research, library resources or information about our academic network and programmes, contact us and visit our Olympic World Library: studies.centre@olympic.org olympics.com/studies olympics.com/library OlympicStudiesCentre linkedin.com/showcase/olympic-studies-centre"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 78,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg79.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 79,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg80.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 80-title\" style=\"top:102px;left:42px;\" src=\"/124/static/_content/80-title-1.png\"/>\n        <img class=\"abs halfScale 80-caption\" style=\"top:162px;left:43px;\" src=\"/124/static/_content/80-caption-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg80Anim = new TimelineMax();\n          pg80Anim.fromTo(cOf(\"80-title\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"80-caption\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg80Anim.stop();\n        }\n      ",
    "searchText": "80  Obituaries  OBITUARIES  We remember Olympians and ﬁ gures from the Olympic Movement who have passed away  EVGENiA SHiSHKOVA AND VADiM NAUMOV  OLEGARiO VÁZQUEZ RAÑA  Olympians and former world ﬁgure skating champions Evgenia Shishkova and Vadim Naumov were among the passengers killed in a plane crash in Washington DC, USA in January. As pairs skaters, the duo won gold at the 1994 World Figure Skating Championships and also claimed the 1995-96 Grand Prix Final title. They skated in the Olympic Winter Games Albertville 1992 and Lillehammer 1994, before marrying in 1995 and retiring from competition. The couple relocated to the US and began coaching, training a number of athletes at the International Skating Center of Connecticut and the Skating Club of Boston, including their son Maxim Naumov, the 2020 US junior national champion.  IOC Honorary Member who represented Mexico in shooting at four editions of the Olympic Games Olegario Vázquez Raña, a four-time Olympian and dedicated sports administrator, has passed away at the age of 89. After representing Mexico in shooting at the Olympic Games Tokyo 1964, Mexico City 1968, Munich 1972 and Montreal 1976, he went on to hold many leadership roles in sport and became the longest-serving President of the International Shooting Sport Federation, from 1980 to 2018. In 1995, he was elected as an IOC Member, contributing to several key IOC commissions before becoming an IOC Honorary Member in 2016. Vázquez Raña was recognised with numerous distinctions, including the Olympic Order, and was named Mexican Athlete of the 20th Century by the National Sports Commission and the Ministry of Education in 2000.  AKiNORi NAKAYAMA  DiCK BUTTON  DRAŽEN DALiPAGiĆ  Two-time Olympic ﬁgure skating champion Dick Button has passed away, aged 95. Button landed the ﬁrst-ever double axel while clinching gold at the Olympic Winter Games St. Moritz 1948, where he became the ﬁrst American to win the men’s singles event. Four years later, he made history again by winning gold at Oslo 1952 with the ﬁrst triple jump in international competition. Button went on to enjoy a successful broadcasting career in the US, where he became known as the “Voice of Figure Skating”.  Three-time Olympic basketball medallist Dražen Dalipagić has died, aged 73. Dalipagić was one of the most decorated players in world basketball, having won the 1978 FIBA World Cup, the 1973, 1975 and 1977 EuroBasket titles, and three Olympic medals as part of the Yugoslavian team. He won a full set of Olympic medals – gold at Moscow 1980, silver at Montreal 1976 and bronze at Los Angeles 1984 – and was inducted into the FIBA Hall of Fame and the Naismith Memorial Basketball Hall of Fame.  Ten-time Olympic gymnastics medallist Akinori Nakayama has died, aged 82. One of Japan’s greatest-ever gymnasts, Nakayama was the most successful male athlete at the Olympic Games Mexico City 1968, winning gold medals in four of the eight events, as well as one silver and one bronze. He won a further four Olympic medals at Munich 1972 as well as seven world championship gold medals during his long career."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 80,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg81.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  81  Issue 124  IRiS CUMMiNGS  ÁGNES KELETi Gymnast and 10-time Olympic medallist who was the most successful athlete at Melbourne 1956 Ágnes Keleti, who had been the oldest living Olympic medal winner, has passed away at the age of 103. The Hungarian was a 10-time Olympic medallist in artistic gymnastics, winning ﬁve gold, three silver and two bronze medals. A national champion in 1937 aged 16, Keleti’s Olympic ambitions were initially curtailed due to the outbreak of World War II, which saw her go into hiding due to her Jewish ancestry. After surviving the Holocaust, Keleti missed the Olympic Games London 1948 due to a ligament injury, eventually making her Olympic debut in Helsinki in 1952, where she won one gold medal, one silver and two bronze. She won a further six Olympic medals at Melbourne 1956, four of which were gold, to become the most successful athlete at the Games.  Iris Cummings, the last-known surviving participant at the Olympic Games Berlin 1936, has died at the age of 104. Born in Los Angeles, USA in 1920, she attended the Olympic Games Los Angeles 1932 as a spectator and was inspired to begin competitive swimming the following year. After winning the US national 200m breaststroke title in 1936, she was selected to compete at Berlin 1936, ﬁnishing fourth in her heat.  POPE FRANCiS His Holiness Pope Francis has passed away at the age of 88. As the head of the Catholic Church, Pope Francis was a constant supporter of the Olympic Movement and was awarded the Olympic Order in Gold in 2013 during a ceremony at the Vatican, in recognition of his understanding of the good that sport can do for young people and the desire to build peace. In 2016, the Vatican, the United Nations and the IOC organised the Faith and Sport conference, which was held under the Pope’s leadership and was an expression of the importance of his commitment to sport.  BUVAiSAR SAiTiEV Three-time Olympic freestyle wrestling champion Buvaisar Saitiev has died at the age of 49. Saitiev won gold in the 74kg category at the Olympic Games in 1996, 2004 and 2008, while he was also crowned world champion six times between 1995 and 2005. Widely regarded as one of the greatest freestyle wrestlers of all time, Saitiev also won six European titles during his career.  NORAiR NURiKYAN Norair Nurikyan, Bulgaria’s ﬁrst Olympic medallist in weightlifting, has passed away, aged 76. Nurikyan won gold in the 60kg category at the Olympic Games Munich 1972, launching a hugely successful era for Bulgarian weightlifting. The country’s athletes have since won a further 38 medals at the Games, including another gold for Nurikyan at the Olympic Games Montreal 1976. He was inducted into the International Weightlifting Federation Hall of Fame in 1994.  GEORGE FOREMAN American boxer George Foreman, an Olympic gold medallist in 1968, has passed away, aged 76. Foreman turned professional after winning heavyweight gold at the Olympic Games Mexico City 1968 and went on to win the world title in 1973 against the then-undefeated Joe Frazier. He suffered his ﬁrst professional loss to Muhammad Ali in the celebrated “Rumble in the Jungle” ﬁght in 1974, before retiring from the sport three years later. Foreman made a dramatic return to the ring in 1987 and, in 1994, became the oldest world heavyweight champion in history at 45 years old."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 81,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg82.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 82-title\" style=\"top:95px;left:146px;\" src=\"/124/static/_content/82-title-1.png\"/>\n        <img class=\"abs halfScale 82-caption\" style=\"top:149px;left:126px;\" src=\"/124/static/_content/82-caption-1.png\"/>\n\n        <img class=\"abs halfScaleC 82-icon\" style=\"top:165px;left:306px;\" src=\"/124/static/_content/82-icon-1.png\"/>\n        <img class=\"abs halfScaleC 82-icon\" style=\"top:265px;left:268px;\" src=\"/124/static/_content/82-icon-2.png\"/>\n        <img class=\"abs halfScaleC 82-icon\" style=\"top:397px;left:255px;\" src=\"/124/static/_content/82-icon-3.png\"/>\n        <img class=\"abs halfScaleC 82-icon\" style=\"top:434px;left:270px;\" src=\"/124/static/_content/82-icon-4.png\"/>\n        <img class=\"abs halfScaleC 82-icon\" style=\"top:409px;left:306px;\" src=\"/124/static/_content/82-icon-5.png\"/>\n        <img class=\"abs halfScaleC 82-icon\" style=\"top:409px;left:190px;\" src=\"/124/static/_content/82-icon-6.png\"/>\n        <img class=\"abs halfScaleC 82-icon\" style=\"top:434px;left:54px;\" src=\"/124/static/_content/82-icon-7.png\"/>\n        <img class=\"abs halfScaleC 82-icon\" style=\"top:398px;left:2px;\" src=\"/124/static/_content/82-icon-8.png\"/>\n        <img class=\"abs halfScaleC 82-icon\" style=\"top:264px;left:54px;\" src=\"/124/static/_content/82-icon-9.png\"/>\n        <img class=\"abs halfScaleC 82-icon\" style=\"top:165px;left:190px;\" src=\"/124/static/_content/82-icon-10.png\"/>\n\n        <img class=\"abs halfScale 82-line-1\" style=\"top:198px;left:390px;\" src=\"/124/static/_content/82-line-1.png\"/>\n        <img class=\"abs halfScale 82-line-2\" style=\"top:314px;left:520px;\" src=\"/124/static/_content/82-line-2.png\"/>\n        <img class=\"abs halfScale 82-line-3\" style=\"top:453px;left:588px;\" src=\"/124/static/_content/82-line-3.png\"/>\n        <img class=\"abs halfScale 82-line-4\" style=\"top:669px;left:531px;\" src=\"/124/static/_content/82-line-4.png\"/>\n        <img class=\"abs halfScale 82-line-5\" style=\"top:729px;left:380px;\" src=\"/124/static/_content/82-line-5.png\"/>\n        <img class=\"abs halfScale 82-line-6\" style=\"top:735px;left:274px;\" src=\"/124/static/_content/82-line-6.png\"/>\n        <img class=\"abs halfScale 82-line-7\" style=\"top:669px;left:147px;\" src=\"/124/static/_content/82-line-7.png\"/>\n        <img class=\"abs halfScale 82-line-8\" style=\"top:450px;left:98px;\" src=\"/124/static/_content/82-line-8.png\"/>\n        <img class=\"abs halfScale 82-line-9\" style=\"top:314px;left:138px;\" src=\"/124/static/_content/82-line-9.png\"/>\n        <img class=\"abs halfScale 82-line-10\" style=\"top:198px;left:274px;\" src=\"/124/static/_content/82-line-10.png\"/>\n\n        <img class=\"abs halfScale 82-text-1\" style=\"top:219px;left:432px;\" src=\"/124/static/_content/82-text-1.png\"/>\n        <img class=\"abs halfScale 82-text-2\" style=\"top:334px;left:566px;\" src=\"/124/static/_content/82-text-2.png\"/>\n        <img class=\"abs halfScale 82-text-3\" style=\"top:476px;left:617px;\" src=\"/124/static/_content/82-text-3.png\"/>\n        <img class=\"abs halfScale 82-text-4\" style=\"top:701px;left:564px;\" src=\"/124/static/_content/82-text-4.png\"/>\n        <img class=\"abs halfScale 82-text-5\" style=\"top:751px;left:452px;\" src=\"/124/static/_content/82-text-5.png\"/>\n        <img class=\"abs halfScale 82-text-6\" style=\"top:763px;left:211px;\" src=\"/124/static/_content/82-text-6.png\"/>\n        <img class=\"abs halfScale 82-text-7\" style=\"top:652px;left:41px;\" src=\"/124/static/_content/82-text-7.png\"/>\n        <img class=\"abs halfScale 82-text-8\" style=\"top:474px;left:42px;\" src=\"/124/static/_content/82-text-8.png\"/>\n        <img class=\"abs halfScale 82-text-9\" style=\"top:337px;left:79px;\" src=\"/124/static/_content/82-text-9.png\"/>\n        <img class=\"abs halfScale 82-text-10\" style=\"top:219px;left:184px;\" src=\"/124/static/_content/82-text-10.png\"/>\n\n        <h1 id=\"82-no\" class=\"abs olympic-HeadlineCon 82-no\" style=\"top:181px;left:442px; font-size: 2.25em; font-weight: 900; color: #074ea2; padding: 0px; margin: 0px;\"  data-number='{\"to\": 200000, \"comma\": true, \"append\": \"+\"}' ></h1>\n        <h1 id=\"82-no\" class=\"abs olympic-HeadlineCon 82-no\" style=\"top:296px;left:573px; font-size: 2.25em; font-weight: 900; color: #007dc5; padding: 0px; margin: 0px;\"  data-number='{\"to\": 250000, \"comma\": true, \"append\": \"+\"}' ></h1>\n        <h1 id=\"82-no\" class=\"abs olympic-HeadlineCon 82-no\" style=\"top:438px;left:622px; font-size: 2.25em; font-weight: 900; color: #172c71; padding: 0px; margin: 0px;\"  data-number='{\"to\": 30, \"append\": \"%\", \"preppend\": \">\"}' ></h1>\n        <h1 id=\"82-no\" class=\"abs olympic-HeadlineCon 82-no\" style=\"top:663px;left:578px; font-size: 2.25em; font-weight: 900; color: #007dc5; padding: 0px; margin: 0px;\"  data-number='{\"to\": 10, \"append\": \"M\", \"preppend\": \"USD \"}' ></h1>\n        <h1 id=\"82-no\" class=\"abs olympic-HeadlineCon 82-no\" style=\"top:774px;left:442px; font-size: 2.25em; font-weight: 900; color: #074ea2; padding: 0px; margin: 0px;\"  data-number='{\"to\": 2024, \"preppend\": \"APRIL \"}' ></h1>\n        <h1 id=\"82-no\" class=\"abs olympic-HeadlineCon 82-no\" style=\"top:773px;left:231px; font-size: 2.25em; font-weight: 900; color: #007dc5; padding: 0px; margin: 0px;\"  data-number='{\"to\": 5, \"append\": \"BN\"}' ></h1>\n        <h1 id=\"82-no\" class=\"abs olympic-HeadlineCon 82-no\" style=\"top:662px;left:48px; font-size: 2.25em; font-weight: 900; color: #172c71; padding: 0px; margin: 0px;\"  data-number='{\"to\": 7.7, \"append\": \"BN:\", \"preppend\": \"USD \", \"decimals\": 1 }' ></h1>\n        <h1 id=\"82-no\" class=\"abs olympic-HeadlineCon 82-no\" style=\"top:436px;left:62px; font-size: 2.25em; font-weight: 900; color: #007dc5; padding: 0px; margin: 0px;\"  data-number='{\"to\": 76 }' ></h1>\n        <h1 id=\"82-no\" class=\"abs olympic-HeadlineCon 82-no\" style=\"top:298px;left:93px; font-size: 2.25em; font-weight: 900; color: #172c71; padding: 0px; margin: 0px;\"  data-number='{\"to\": 43, \"append\": \"%\" }' ></h1>\n        <h1 id=\"82-no\" class=\"abs olympic-HeadlineCon 82-no\" style=\"top:181px;left:224px; font-size: 2.25em; font-weight: 900; color: #007dc5; padding: 0px; margin: 0px;\"  data-number='{\"to\": 80, \"append\": \"%\" }' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg82Anim = new TimelineMax();\n          pg82Anim.fromTo(cOf(\"82-title\"), 0.6, {opacity:0, x:100}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"82-caption\"), 0.6, {opacity:0, x:100}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.1)\n          .staggerFromTo(cOf(\"82-icon\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.5)\n\n          .fromTo(cOf(\"82-line-1\"), 0.6, {opacity:0, y:-30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.5)\n          .fromTo(cOf(\"82-line-2\"), 0.6, {opacity:0, y:-30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.6)\n          .fromTo(cOf(\"82-line-3\"), 0.6, {opacity:0, y:-30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.7)\n          .fromTo(cOf(\"82-line-4\"), 0.6, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.8)\n          .fromTo(cOf(\"82-line-5\"), 0.6, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.9)\n          .fromTo(cOf(\"82-line-6\"), 0.6, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2)\n          .fromTo(cOf(\"82-line-7\"), 0.6, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.1)\n          .fromTo(cOf(\"82-line-8\"), 0.6, {opacity:0, y:-30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.2)\n          .fromTo(cOf(\"82-line-9\"), 0.6, {opacity:0, y:-30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.3)\n          .fromTo(cOf(\"82-line-10\"), 0.6, {opacity:0, y:-30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.4)\n\n          .fromTo(cOf(\"82-text-1\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.5)\n          .fromTo(cOf(\"82-text-2\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n          .fromTo(cOf(\"82-text-3\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.7)\n          .fromTo(cOf(\"82-text-4\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.8)\n          .fromTo(cOf(\"82-text-5\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.9)\n          .fromTo(cOf(\"82-text-6\"), 0.6, {opacity:0, x:-50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2)\n          .fromTo(cOf(\"82-text-7\"), 0.6, {opacity:0, x:-50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.1)\n          .fromTo(cOf(\"82-text-8\"), 0.6, {opacity:0, x:-50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)\n          .fromTo(cOf(\"82-text-9\"), 0.6, {opacity:0, x:-50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.3)\n          .fromTo(cOf(\"82-text-10\"), 0.6, {opacity:0, x:-50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.4)\n\n          .fromTo(cOf(\"82-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[0])}}, 1.5)\n          .fromTo(cOf(\"82-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[1])}}, 1.6)\n          .fromTo(cOf(\"82-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[2])}}, 1.7)\n          .fromTo(cOf(\"82-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[3])}}, 1.8)\n          .fromTo(cOf(\"82-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[4])}}, 1.9)\n          .fromTo(cOf(\"82-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[5])}}, 2)\n          .fromTo(cOf(\"82-no\")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[6])}}, 2.1)\n          .fromTo(cOf(\"82-no\")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[7])}}, 2.2)\n          .fromTo(cOf(\"82-no\")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[8])}}, 2.3)\n          .fromTo(cOf(\"82-no\")[9], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[9])}}, 2.4)\n        }\n\n        function onPageLeave() {\n          pg82Anim.stop();\n          resetNumbers(\"82-no\");\n        }\n      ",
    "searchText": "82  The last word  COUNTiNG THE CHANGE  Ten eye-catching highlights from the wide-ranging Olympic Agenda reforms  80%  200,000+  REDUCTiON  MEMBERS OF ATHLETE365:  in the average cost of applying to host the winter or summer editions of the Olympic Games  the IOC’s official community for elite athletes and Olympians  GAMES OF A NEW ERA  43%  250,000+  ATHLETES FRONT AND CENTRE  ATHLETES  OF IOC MEMBERS  supported by the Olympic Solidarity athlete development programme  are women – up from 21% in 2013  GENDER EQUALiTY  76  IOC REFUGEE OLYMPiC TEAM MEMBERS  >30%  SOLiDARiTY SUSTAiNABLE DEVELOPMENT  IOC REFUGEE OLYMPiC TEAM  across Rio 2016, Tokyo 2020 and Paris 2024  RELEVANCE  ECONOMiC AND FiNANCiAL RESiLiENCE  USD 7.7BN:  USD 10M  DiGiTALiSATiON  APPROXiMATELY  5BN PEOPLE  followed Paris 2024  in IOC carbon emissions between 2021 and 2024  CREDiBiLiTY AND GOOD GOVERNANCE  USD 5.2BN TO  the increase in IOC revenue from the Worldwide Olympic Partner (TOP) programme and media rights since the adoption of Olympic Agenda 2020  REDUCTiON  PER OLYMPiAD  dedicated to prevention of competition manipulation  OLYMPiC AI AGENDA launched in  APRiL 2024"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 82,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg83.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 83,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg84.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n\n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n\n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'addContentLink'\n        })\n      }\n\n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n        contentLinksThree.map(function callback(e) {\n          return e.className = 'contentLinkThree addContentLinkThree'\n        })\n      }\n\n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n\n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n\n\n      function pg71_gallery(index) {\n        Publish.openGalleryTwo([[\n          '71-1.jpg',\n          '71-2.jpg',\n          '71-3.jpg',\n          '71-4.jpg',\n          '71-5.jpg',\n          '71-6.jpg',\n          '71-7.jpg',\n          '71-8.jpg',\n          '71-9.jpg',\n          '71-10.jpg',\n          '71-11.jpg',\n          '71-12.jpg',\n        ],\n        index])\n      }\n\n\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["default"].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    if (context.getters.contentsPinned) {
      if (payload.width < 992) {
        var windowWidth = payload.width;
        var mobile = true;
      } else {
        var windowWidth = payload.width - 300;
        var mobile = false;
      }
    } else {
      var windowWidth = payload.width;
    }
    var windowHeight = payload.height - 60;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
    if (context.getters.contentsPinned) {
      if (windowWidth <= 992 && mobile) {
        context.commit('UPDATE_CONTENT_PANEL', false);
      } else {
        context.commit('UPDATE_CONTENT_PANEL', true);
      }
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  scrollZoom: function scrollZoom(context, payload) {
    var zoomLevel = context.state.zoomLevel + payload.zoomDelta;
    zoomLevel = zoomLevel > 2 ? 2 : zoomLevel;
    zoomLevel = zoomLevel < 1 ? 1 : zoomLevel;
    var windowWidthAdjustment = context.getters.contentsPinned ? 300 : 0;
    var newX = payload.x - (window.innerWidth - windowWidthAdjustment) / 2;
    var newY = payload.y - (window.innerHeight + 48) / 2;
    var translateX = context.state.translateX + (newX - context.state.zoomOriginX) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));
    var translateY = context.state.translateY + (newY - context.state.zoomOriginY) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));

    console.log({ zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });

    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  titledPages: function titledPages(state) {
    return state.document.pages.filter(function (page) {
      return page[0].title;
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state, getters) {
    return state.activePanel == "Contents" || getters.contentsPinned;
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isMobileFontLarge: function isMobileFontLarge(state) {
    return state.isMobileFontLarge;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contents.enabled;
  },
  contentsPinned: function contentsPinned(state, getters) {
    return state.document.options.contents.pinned && getters.contentsEnabled && !getters.isMobile && !getters.isFullscreen;
  },
  contentsNumbers: function contentsNumbers(state) {
    return state.document.options.contents.numbers;
  },
  contentsTitles: function contentsTitles(state) {
    return state.document.options.contents.titles;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomNavEnabled: function zoomNavEnabled(state) {
    return state.document.options.zoom.navEnabled;
  },
  zoomClickEnabled: function zoomClickEnabled(state) {
    return state.document.options.zoom.clickEnabled;
  },
  zoomScrollEnabled: function zoomScrollEnabled(state) {
    return state.document.options.zoom.scrollEnabled;
  },
  zoomSliderEnabled: function zoomSliderEnabled(state) {
    return state.document.options.zoom.sliderEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoom.navEnabled || state.document.options.zoom.clickEnabled || state.document.options.zoom.scrollEnabled || state.document.options.zoom.sliderEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  fullscreenEnabled: function fullscreenEnabled(state) {
    return state.document.options.fullscreenEnabled && document.documentElement.requestFullscreen;
  },
  isFullscreen: function isFullscreen(state) {
    return state.isFullscreen;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {};

    styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";

    styleObject.transform = "scale(" + getters.pageContainerZoomLevel * state.pageScale + ") translate(" + state.translateX + "px, " + state.translateY + "px)";

    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/epsilon.js
var epsilon = __webpack_require__("NnIC");
var epsilon_default = /*#__PURE__*/__webpack_require__.n(epsilon);

// CONCATENATED MODULE: ./src/store/mutations.js



var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FONT_SIZE, function (state) {
  state.isMobileFontLarge = !state.isMobileFontLarge;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FULLSCREEN, function (state) {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
    state.isFullscreen = true;
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_FULLSCREEN, function (state) {
  if (document.fullscreenElement || window.fullscreenElement) {
    state.isFullscreen = true;
  } else {
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.translateX = payload.translateX || state.translateX;
  state.translateY = payload.translateY || state.translateY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;

  if (state.zoomLevel <= 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
    state.translateX = 0;
    state.translateY = 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, SLIDE_ZOOM, function (state, payload) {
  var zoomDelta = payload.zoomValue - state.zoomLevel;

  if (zoomDelta < 0) {
    var zoomDeltaScale = zoomDelta / (1 - state.zoomLevel);
    state.zoomOriginX = state.zoomOriginX * (1 - zoomDeltaScale);
    state.zoomOriginY = state.zoomOriginY * (1 - zoomDeltaScale);
  }

  state.zoomLevel = payload.zoomValue || state.zoomLevel;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_CONTENT_PANEL, function (state, payload) {
  state.contentsPanel = payload;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var contents_state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: contents_state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["default"].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    contentsPanel: true,
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    translateX: 0,
    translateY: 0,
    isDoublePage: false,
    isFullscreen: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476,
    isMobileFontLarge: false
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("wheel", this.mouseWheelHandler, { passive: false });
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed && mouse.y > 50) {
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.ctrlKey) {
      e.preventDefault();
      mouse.x = e.clientX;
      mouse.y = e.clientY;

      if (e.wheelDelta > 0) {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: 0.08
        });
      } else {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: -0.08
        });
      }
    } else {
      if (e.wheelDelta > 0) {
        Publish.goToPreviousSection();
      } else {
        Publish.goToNextSection();
      }
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomClickEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
    document.addEventListener('fullscreenchange', this.updateFullscreen);
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  updateFullscreen: function updateFullscreen() {
    Publish.updateFullscreen();
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(vue_gtag_esm["a" /* default */], {
  config: { id: "G-KTMLHQ2P7Y" }
}, router);

/* eslint-disable no-new */
window.Publish = new vue_esm["default"]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "zoomClickEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM",
    updateFullscreen: "UPDATE_FULLSCREEN"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "scrollZoom", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "OT+5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Om6c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tnot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vhpl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WpSr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z1YF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hIWI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hLNX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hxKv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nSix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o4GY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r8RT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rMvo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.0d7c01aaf7378d11037a.js